function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnlineWorld(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-86"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "59.51 406.65 106.67 406.4 153.84 406.32 248.17 406.15 342.5 406.31 389.66 406.4 436.82 406.65 389.66 406.89 342.5 406.98 248.17 407.15 153.84 406.98 106.67 406.89 59.51 406.65",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-86"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 436.7,
    rx: 114.48,
    ry: 17.16,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-86"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346,115.19V423.5a16.31,16.31,0,0,1-16.15,16.44H170.31a16.3,16.3,0,0,1-16.13-16.44V115.19a16.29,16.29,0,0,1,16.13-16.44H329.8A16.3,16.3,0,0,1,346,115.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.86,130.67V413.35c0,8.64-6.47,15.64-14.45,15.64H178.73c-8,0-14.47-7-14.47-15.64V130.67c0-17.61,6.47-21.5,14.47-21.5H207.3c1.66,0,3,1.88,3,4.22v1c0,5.48,3,5.5,6.69,5.5h66.1c3.71,0,6.69,0,6.69-5.5v-1c0-2.34,1.34-4.22,3-4.22h28.59C329.39,109.17,335.86,114.54,335.86,130.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.07,113.06h-18a1.12,1.12,0,0,1-1.12-1.12h0a1.12,1.12,0,0,1,1.12-1.11h18a1.12,1.12,0,0,1,1.12,1.11h0A1.12,1.12,0,0,1,259.07,113.06Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Map--inject-86"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.6,305c.38,1.65.4,1.63-.5,2.94-1.11,1.64-2.24,3.25-3.37,4.87a4.72,4.72,0,0,0-1.21,2.3c-.19,2.4-.35,4.78-.53,7.16-.1,1.57-1.75,3.2-2.56,4.45-.36.55-.65,1.46-1.29,1.5s-2.06-.18-2.56.18c-1.58,1.07-3.15,2.16-4.72,3.23-.33.22-.31,2.58-.37,3s0,1.37-.28,1.76c-1.29,1.69-2.6,3.37-3.91,5s-2.38,3.09-3.59,4.6c-.27.36-4-1.27-4.6-1.45-.35,1.29,1.79,1.43,2,2.54a7.19,7.19,0,0,1,.45,2.14,5.77,5.77,0,0,1-1.09,1.59c-.79,1.17-1.84,1.15-3.11,1.49a5.31,5.31,0,0,1-3.06,0c.24.79.44,1.13.14,1.88-.16.46,0,1.23-.23,1.41-1.25.89-2,.51-3.26-.14a9.6,9.6,0,0,0,0,2.14c.1.46.84,1.25.66,1.69-.4.85-.8,1.7-1.19,2.57s-.52.74-1.41,1-.89.83-1.27,1.56c-.24.44.68,1.31.95,1.69s1.49.06,1.27.87a3.8,3.8,0,0,1-.89,1.67,5.89,5.89,0,0,0-1.29,1.76c-.32,1-.59,1.07-1.47,1.59s.1,3.21.26,4.2c.08.36.06,1.21.34,1.45l2,1.7c1.15,1,1.94.82,3.43.84l-4.06,1.84c-1.07.5-1.27.22-2.38-.32l-4.78-2.3c-.82-.39-1-1.31-1.33-2.2-.89-2.1-2.34-4.18-2.08-6.52.39-3.51.79-7,1.19-10.49s.53-6.88,1.15-10.19c.81-4.19,1.6-8.39,2.38-12.56.49-2.57,1-5.11,1.46-7.65a25,25,0,0,0,.64-3.41,18.06,18.06,0,0,0-.36-2.92,9.11,9.11,0,0,0-.32-2.59c-.35-.54-1.48-1-2-1.39-1-.66-2-1.35-3-2A6,6,0,0,1,140,315l-3.63-6.79c-1-1.86-2-3.72-3-5.59-.6-1.15.42-3.27.71-4.46a8.07,8.07,0,0,1,.58-2.38l1.72-2.2c1.27-1.63,2.36-2.56,2-4.86-.06-.53-.38-.81,0-1.19.06,0-.14-.79-.06-1.05.14-.71-1.39-1.33-1.23-2s.16-.72-.52-1.11c-.49-.3-.49-.26-1,0a4.39,4.39,0,0,0-1,.81c-.18.16.32.77.45.95-1,.42-.95.54-1.4-.53-.2.59-1.19-.4-1.73-.5-.28-.06-.47.26-.65.14l-.88-.69c-.63-.46-1.84-1-2.24-1.71s-.19-1.43-.65-2c-1.17-1.33-1.88-2.52-3.49-3-1.25-.35-3.35-.43-4.34-1.42l-2.6-2.56c-.56-.56-1.37,0-2.06.25-1.53.46-3.12-.65-4.6-1.26-1.19-.48-2.38-.94-3.57-1.43-.36-.16-1.07-.26-1.37-.56-.77-.79-1.53-1.58-2.32-2.36s-.28-1.17,0-2.18c.18-.67-1.05-2-1.39-2.48a6.82,6.82,0,0,0-1.23-1.48L98.06,259c-.18-.16.06-.7.1-.94s-.4-.67-.55-.83a11.2,11.2,0,0,0-1.83-2c-.63-.48-1.29-.76-1.53-1.59-.13-.45-.49-2.62-.85-2.81-.79-.34-1.56-.7-2.32-1.05.24.87.42,2.59,1,3.25a10.94,10.94,0,0,1,2.05,3,2.93,2.93,0,0,0,1,1.39,3.36,3.36,0,0,1,.73,1.49,5.56,5.56,0,0,1,.5,1.7c0,.95.45.26.73.48s1,.81.89,1.29c-.1.65-.67.79-.93.31a7.48,7.48,0,0,0-2.44-2.28c-.26-.19-.16-1.38-.18-1.7,0-.5-.79-.85-1.13-1.15s-.69-.14-1-.48S91.4,256.36,91,256c.52-.06,1.71-.16,1-1.15a4,4,0,0,0-1.74-1.74c-.58-.3-.74-1.27-1-1.89L88.09,248a5,5,0,0,0-3-2.46c-.87-.22-1.17-.16-1.56-.93a.67.67,0,0,1-.06-.12l-1.33-2.86c-.64-1.42-1.92-2.28-2.38-3.84a14.47,14.47,0,0,1-.44-5.42c.08-1.78.18-3.53.28-5.31a10.89,10.89,0,0,0-.87-4.42,24.13,24.13,0,0,1,2.89.89c0-1.43.1-1.61-.83-2.62a12.07,12.07,0,0,0-2.18-1.84,10.63,10.63,0,0,0-2.28-.87c-1.27-.56-1.47-.6-2.06-1.95-.64-1.58-3-2.4-2.82-4.14s0-1.47-1.27-2.3c-.18-.1-1,1.6-1.49.77-.41-.63-1.05-2.22-1.68-2.52a3.1,3.1,0,0,1-1.65-1.52,18.13,18.13,0,0,0-1.78-2.66,14.32,14.32,0,0,0-2.08-1.45,19.72,19.72,0,0,0-4.82-2.34c-.7-.26-1.57.34-2.28.18a10.86,10.86,0,0,1-2.3-1.41,2.83,2.83,0,0,0-2.2-.69c-.92.1-1.39.35-1,1.52.28,1-3.47,2-4.28,2.26a.57.57,0,0,1,.42-.85c-.64-.18-.16-2,.25-2.24a3.9,3.9,0,0,1,2.44-.51c-.25-.22-.49-.44-.71-.66l.83-.61A7.4,7.4,0,0,0,44,198.85a9.43,9.43,0,0,0-2.48,3.31c.39.1.77.2,1.15.28A16.81,16.81,0,0,1,38.89,206c-.75.54-3.13,1.15-3.23,2.26s-3.16,1.59-4,1.85a5.83,5.83,0,0,1-1.11.17c-.44.06-.22.3-.57.52a2.22,2.22,0,0,1-2.07.44,11.46,11.46,0,0,1,2.34-1.43c.64-.38,2.5-2.18,3.06-1.19.41-.7,1.9-2.36,2.71-1.79-.29-.77,1.11-1.25,1.27-2.1a1.88,1.88,0,0,1,.6-1.37c.3-.31.61-.47.3-.93-1,.56-2.09,1.45-3.12.68-.37-.24-1.05-1-1.47-.84l-1.58.7-.54-3.2c-.27.14-1.64,1.15-1.84,1-.5-.42-1.49-.92-1.83-1.51a9.55,9.55,0,0,1-.59-2.62c-.14-.61.36-1.09.67-1.59.58-1,.52-1.3,1.61-1.19.91.08,1.05-.65,1.84-1s1.45.3,1.83-.69c.3-.79-.16-.93-.68-1.51l.72-.43c-.34-1-1.17-.12-1.75.23-.75.42-.87-.08-1.62,0-1.49.18-3.16.48-4-1.13.18-.06.36-.25.54-.29-.72-.26-1.69-.36-2.2-1.08a6,6,0,0,1,3-1.07,3.75,3.75,0,0,0-.26-.33,4.92,4.92,0,0,1,2.46-.7c0,1.19.87,1,1.77,1.25s1-.16,1.76-.65c-.32-.14-.65-.28-1-.4l.38-.16c-.36-.28-.48-.61-.1-.89a9.92,9.92,0,0,1-2.38-.46c-.64-.23-.64-1.27-1.29-1.58-.44-.22-2.32-.72-2.52-1.19-.08-.18.34-1.09.4-1.31s.49-.12.61-.12c.71-.06,1.79.18,2.24-.48a11.91,11.91,0,0,1,1.65-2.12,8.08,8.08,0,0,1,4.1-1.9,4.74,4.74,0,0,0,2.48-.77c1.07-.84,1-.86,2.16-.26s4-.2,4.42,1.07c.32.93,3.38.85,4.39,1,1.54.2,3.05.38,4.58.65l6.72,1.19A20.71,20.71,0,0,1,64,180.43c.24.12,1.81-1.79,2-2,.43-.42,1.23.83,1.72.61.79-.34,4.36-2.52,4.88-1.68l-3.89,2.06c1,.71,4.31-2.2,4.6-1,.4-.44.78-.9,1.17-1.35s-.47-.48.1-.95a43.64,43.64,0,0,0,3.08,3.27,3.83,3.83,0,0,1,1.32-2.2c.48.51-.39.75.3,1.13.24.14-.16.69-.28.93.42-.12,1.25-.12,1.59-.4.12-.12-.16-.65.08-.67l.73-.12c.86-.12,2,.71,2.82,1.07a37.85,37.85,0,0,0,5.29,1.43l-.13-.38a4.67,4.67,0,0,1,2.65,1.21c.7.48-1.48,1.25-1.64,1.31a6.33,6.33,0,0,0,2.28.57l3.77-.31c.59,0,1.62-.22,2,.41.59.86,1.15,1.71,1.74,2.58-.08-.37-.18-.75-.27-1.13-.06-.22.19-.43.15-.65-.15-.88-.53-.66,0-1.53.34-.59,2.9-.67,2.34-1.55a8.06,8.06,0,0,1-3.49.86c.3-1.13.76-1,1.79-1.35s1.21-.46,2.18.1c.28.16.44.81.61,1.09s.48.35.88.43a16,16,0,0,1,2.32.72c.65.24,4.24.67,4.38.16.3-1,.36-1.51,1.49-1.51a9.27,9.27,0,0,1,2.2.57c-.1.34-.54,1.37-.42,1.67s1.11.75,1.39.93c-.38-1.17-.81-2.18.63-2.4.58-.1.92-.63,1.35-1s.1-.71,0-1.13c-.37.18-.73.36-1.09.52-.14-1.15.68-1.33,1.49-1.39,0-.91-.89-.26-1.43-.46s-1.94-.47-2.12-.93a5.72,5.72,0,0,1-.36-2.68c0-1,.48-1.17,1.27-.85.14-.51-.2-.69-.61-.63.77-.5.87-.44.85-1.41a3.63,3.63,0,0,0-.44-2,4,4,0,0,1,0-2c0-.51.84-.24,1.23-.22-1.4-1.56,1.07-1.11,2-1.11a11.25,11.25,0,0,1,3.55.5c-.54.79-1.27,2.48-2,2.95s-2.36.06-3.09.06c2.32.34-.34,1.83-.2,2.58,1.17-.2,1.83.83,2.06,1.93.14.73,1.29,1.6,1.75,2.16-.56.39-1.15.77-1.71,1.15.56.23,1,.61,1.55.25s1,.08,1.55.34c-.26.2-.54.38-.8.56.54.49.82.49.64,1.23s-.3.91.36,1.34a3.05,3.05,0,0,0,.69-1.56c0-.26.24-1.35.73-1.07.3.2,1.35.61,1.43,1,.14.65.54,1.37-.24,1.64,0-.17-.08-.33-.08-.49-1.6.89,2,4.1,2.13,2.36,0-.48,0-.79.33-1.09.16-.16.7-.46.7-.74,0-1.3,0-1.22,1.11-1.7-.44-.69-.84-1-.68-1.83s.6-.61,1.33-.49c.46.08,1.75,0,2.1.4a2.28,2.28,0,0,0,1.69,1c-.38.69.22,1.13-.18,1.6-.24.3-1.11.18-1.47.22a5.74,5.74,0,0,0,1.09,1.83c.58.55.84,1,.22,1.78a7.41,7.41,0,0,1-2,1.21c-.54.34-.93-.38-1.37-.79l.67,1.52-1-.55a4,4,0,0,0,.12.43l-1-.25c-.24-.06-.06-.66-.28-.66-.55,0-1.3-.2-1.56.42l1,.57a4.12,4.12,0,0,1-1.19,1.49c-.79.44-1.07.08-1.88-.36a8.09,8.09,0,0,0-3.75-.65l2.89,1.45a9,9,0,0,0,2.66.35c-.32.52-.83,1.95-1.35,2.19a2.44,2.44,0,0,1-1,.43c-.4,0-.79-.18-1.15.06-1.07.77-1.15.81-2.36.44-.77-.24-1.53-.42-2.3-.62l1.53.68c-.12.1-.18.24-.3.35a1.65,1.65,0,0,1,1.68.22c.38.22,1,.78.34,1.09a3,3,0,0,1-1.78.28c-.24,0-.62.85-.76,1a10.67,10.67,0,0,0-1.82,3.17c-.28,1.33-.54,2.66-.85,4,.55.14,1.7.14,2.1.5s.71,2,.93,2.55c.38,1.06.62.68,1.65.46a3.31,3.31,0,0,1,1.66.42,15.06,15.06,0,0,1,4,2.06c.43.3,1.27,1.21,1.78,1.25.78.08,1.55.18,2.32.24.26,0,1.73,0,1.73.35,0,1.07-.1,2.11-.14,3.18-.06,1.5,1.43,2.63,2.28,3.7s2.64-.89,2.5-1.8l-.48-2.86c-.08-.51-.75-1.17-1-1.6.93-.6,2.74-1.29,3.39-2.22s.72-3.12,0-3.85a12.17,12.17,0,0,1-1.43-1.53c-.59-.85-.79-.77,0-1.46s.86-.62.56-1.71a3.77,3.77,0,0,1-.34-1.9,2.86,2.86,0,0,0,0-2.36c-.2-.68.22-.9.91-1,1.27-.14,2.44.95,3.69.37.78-.37,1,.06,1.71.58.34.24,1.35.67,1.45,1.13.19.71.59,1.25,1.36,1.13a2.51,2.51,0,0,1,1.61.49c-.32.56-.52.72-.42,1.37a3.07,3.07,0,0,1,.06,1.75c.16,0,.34,0,.5,0-.3.39-1.17,1-.71,1.44.81-2.43,3.74,2.86,4.34-.41.12.14.36.16.51.3.32-.68.84-1.35.7-2.13-.1-.55.71-1.64,1.25-1.5-.08.29-.14.57-.2.87,1.27.06,2.12,2.64,2.7,3.67.35.59,1.36,1.76,1.4,2.4,0,.37-.61.87-.53,1.23,0,.16.67.53.77.63.28.22.85.5,1,.83s-.16.8.36.82a3.43,3.43,0,0,1,2.18.63c.54.38,1.65.89.44,1.07a17.4,17.4,0,0,0-2,.58c.4.16.94-.14,1.37-.26-.3.52-1.25.59-1.78.75s-.36,1.19-.08.82a1.39,1.39,0,0,1,.79-.5c.3-.1.18-.28.38-.38a3.47,3.47,0,0,1,1.55-.45.86.86,0,0,1-.58-.3c.38,0,1.13,0,1.29.48s-.44.55-.08,1c.44-.78,1-.36,1.65-.14s.13,1.21,0,1.53c-.22.61.49.81,0,1.5a4.13,4.13,0,0,1-1.49.92c-.52.15-1,0-1.65.23s-.83.54-1.27,1.05a3,3,0,0,1-3,1,23.65,23.65,0,0,0-4-.1c-1.21.08-2.44-.32-2.77,1.27-.08.43-1.25.55-1.55.77a10.09,10.09,0,0,0-1.41,1.51,18.22,18.22,0,0,1-2.18,2.59c1.61-.79,2.48-2.49,4.07-3.27,1.11-.53,4.12-2.22,4.91-.24-.15-.08-.29-.1-.43-.17.83.55-.28,1-.68,1.32s-.95-.35-1.56.08c.25.06.83.7.87.7a1.7,1.7,0,0,1,1.09-.06,1.76,1.76,0,0,1-.71,1.11c.19-.06.41,0,.61,0-.3.85.58,1.53,1.23,1.7a1.53,1.53,0,0,0-.22.16c.93.44,1.85.82,2.66.24,0,.14.06.28.08.44a1.43,1.43,0,0,0,.57-.16c-.57-.72.54-1.75.92-2.34.75.26.33.91.17,1.47.52-.4,1.29.41.82.61a3.09,3.09,0,0,1-1.83.5c.14.13.22.35.36.49-.77.3-1.51.6-2.28.93a2.29,2.29,0,0,0-.85.4c-.32.28-.4-.38-.68-.16-.53.42-1,1.23-1.56,1.75-.36.37-.72-.14-1-.22-.81-1.15,1.13-2.14,1.79-2.62.47-.32.22.06.44.26.43.36.69-.14,1.09-.5-.5,0-1.15-.2-1.59.1a1.76,1.76,0,0,1,.42-.81c-.6-.16-1.35.63-1.85.95-.3.2-.3-.26-.69.16-.18.22-.6.1-.86.1.38,1.23-1.72.79-2,1.35a3.08,3.08,0,0,0-.24-.26c-.33.67-.65.73-1.25,1-.43.16-.45.46-.61.91-.26.64-1.45,2.84.18,2.66l-.12-.3a1.7,1.7,0,0,1,.34.4c-.48.34-1.07,0-1.57-.08-.26-.06-.18.69-.54.71a4.76,4.76,0,0,0-2.77.84c.73-.08,1.33-.44,2.06-.56a1.88,1.88,0,0,1-.24.18c.2,0,.4.06.6,0a3.34,3.34,0,0,1-1.41.54c-.44,0-1.25-.14-1.51.35,1.11.14-.51,2.26-.91,2.6.26-.46-.53-.77-.71-1.31,0,.66.85,1.53.57,2.14a13.79,13.79,0,0,0-1,1.93l-.12,0a3.18,3.18,0,0,1,.38-1.25c-.3-.18-.16-.76-.72-.6a4.57,4.57,0,0,1,.28-1.29c0-.08.4-.93,0-.63-.95.69-.67,1.13-.41,2.3a2.46,2.46,0,0,0-.9-.48c.24.36.82.46,1,.8s-.21,1-.13,1.31c.15.47.79.23.61,1s-.52.57-1.07.75c.46,0,1.29-.16,1.17.54,0,.31-1,.33-1.29.37.14.08.26.22.4.3-.2.08-.32.22-.58.2.22.59.56.06,1,.28-.27.17-.53.31-.79.45s-.51-.22-.67-.12c-.32.18-.64.92-.88,1.27s-.73.12-1,.5a4.19,4.19,0,0,1-.89,1,4.46,4.46,0,0,0-2.2,2.5,3.5,3.5,0,0,0,.2,2.5,23.25,23.25,0,0,1,1.27,3.45c.19.65.37,2.3-.1,2.77s-.66.8-1.07.24c-.12-.18-.88-.87-.88-.93a13.24,13.24,0,0,0-.57-1.37c-.22-.51-.48-.79-.32-1.39l-.28.24c-.23-.77.48-1.86-.29-2.38s-1-1.37-1.81-1.11c-.43.14-.87.44-1.27.18a6.8,6.8,0,0,0-1.21-.79c-.69-.18-1.86.73-2.06-.44-.14,1-2.4.28-3.09.83.49,0,2.22.26.91.88.14.07.85.31.87.45.1.36-.22.5-.47.46.19-.48-.52-.66-.86-.86.08.34-.06.44-.08.7-.31-.66-.59,0-1-.3s-.77-.79-1.4-.57a.57.57,0,0,1-.26,0,4,4,0,0,1-.95-.34c-.64-.24-1.65.49-2.28.75-1,.4-3.42,2.2-3.42,3.67,0,.44.58.89.6,1.33a4.35,4.35,0,0,1-.3,1.11,9.23,9.23,0,0,0-.57,2.44,8.9,8.9,0,0,0,1.44,5.35c.68,1,.94,1.75,2,2.07.25.09.61.65.81.59l1.37-.53a4.47,4.47,0,0,1,1.23-.28c.35,0,.61.41.77.33a2.62,2.62,0,0,0,.58-.29c.1-.08-.16-.36,0-.5a1.91,1.91,0,0,0,.75-1c.26-.89.18-1.92,1.11-2.3a7.58,7.58,0,0,1,2.08-.4c.54.06,2.06-.25,1.57.88-.2.47-.81,1.8-1.13,1.84.16.08.06.26.45.24-.15.12-.25.28-.41.39l.08.1.2-.15a9.21,9.21,0,0,0-.44,1.66,1.17,1.17,0,0,1-.26-1,3.06,3.06,0,0,0-.37.63c.71,0-.1,1.41.13,1.91s-.55,1.29-.85,1.58c1,.36,2,.08,3.09.26.42.06.72-.32,1.15-.26a6.83,6.83,0,0,1,1.57.22,1.94,1.94,0,0,1,1.37,2.16c-.12.7-.22,1.39-.34,2.09-.06.41-.39.77-.45,1.15-.24,1.9,2.06,5,3.78,4.28,1.06-.42,1.61-.87,2.74-.52a4.75,4.75,0,0,1,2.3,1.79c-.06-1.35,1.59-3.17,2.24-4.25.2-.35,1.43-.55,1.77-.67l2.71-1c.82-.3,2.34.42,3.14.61l6.44,1.51c1.15.26,2.34.28,3.23,1.13l5,4.82c1.05,1,3.35,1,4.7,1.37s2.24,2.4,3,3.43,1.59,2.12,2.4,3.17c.2.26.62,1.09.92,1.19l5.17,1.88c1.73.62,3.45,1.23,5.16,1.87,1.44.51,2.91,2.08,4.18,3,.24,0,1.83,0,1.87.22C191.24,303.49,191.42,304.25,191.6,305Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.77,168c-.28.19-.56.35-.82.53.18.06.32.28.52.36L111.8,170c1.1,0,1.35-.2,1.83.89.14-.14.4-.14.55-.3l.36.86a5.25,5.25,0,0,0-.69.25c1.5.52-.78,2.05-1.61,1.69.2.63-.61,1-1.09.93s-.91-.79-1.31-1.29c-.87-1.11-2.1-1.39-3.17-2.24-.56-.47.1-.87.57-1s.92.83,1.35.91c.91.16.89-.67.89-1.31,0-.33-1.3-.67-1.58-.79.24-.22.65-.93.95-1,.71,0,1.05-.26,1.69.06s.93.14,1.66-.1S113.15,167.68,113.77,168Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420,163.93c-.18-.81,1.37-1.65,1.41-.32.56-.51,1.23-.31,1.9-.29-.07.17,0,.37-.05.55a2.46,2.46,0,0,1,1.84-.12c.14,0,.93.14,1,.3a1.9,1.9,0,0,1-.12.91,10.38,10.38,0,0,1-3.92.46C421.69,165.16,420.08,164.35,420,163.93Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.84,187.07c-.43.36-1.09,1.17-1.62,1.31s-1.29-.2-1.77-.28c0,.82.14,1.09-.57,1.41-.5.24-.06,1,.06,1.55a3.35,3.35,0,0,1-2-.83c-.46-.34-1.49.27-1.63-.3-.2-.83-.08-1.61-.91-1.67s-1.79-.12-2.68-.2c-.54,0,.36-1.64-.81-1.46-.6.1-.36,1.64-.4,2.22,0,1-3,1.21-3.83,1.43.68.51,1.51.73,1.55,1.68a4.07,4.07,0,0,0,1.13,2.44c.06.08-.44.75-.57.81s-.88-.18-1.13-.22c-.42-.11-1.41-.53-1.81-.29-1.65,1-3.29,2-4.94,3-1.27.77-2.67,1.19-3.27,2.68-1.15-1.13-1.21-1.27-2.72-1.07s-1.52.26-2.38,1.54c0-.45,0-.91,0-1.36-.45.23-1.26.85-1.74.79s-1.17-.42-1.53.16l-2.46,4c.44.16,2,.34,1.83.86-.32,1.29-.38,1.33.38,2.36-1.29.57-2.44,1.13-1.75,2.81.12.28-1,.7-1.27.8-.61.23-1.17.15-1.23.89s.18,1.62-.65,1.82c-1,.28-1.07.14-1.25,1.29s-1.59,2.28-2.26,3.11c-.84-3.94-3.69-11.44,1-13.76,1.35-.65,2.14-.85,2.93-2.2a8.17,8.17,0,0,1,2.74-2.68c.79-.59,1.86-.91,2.1-2,.18-.79.38-1.57.56-2.36.06-.18,1.13-.28,1.33-.32a5,5,0,0,0-2-.19c-.59.09-.91,1-1.23,1.52a13.2,13.2,0,0,1-2.93,2.54A4.26,4.26,0,0,1,438,196a3.25,3.25,0,0,1-2.18.69c-1,0-1.25-.08-2,.57a25.89,25.89,0,0,0-3.32,3.38c.32.29,1.15.69.9,1.13-.1.19-1.21.25-1.45.29-1.15.14-2.3.28-3.43.4.41-.28.81-.59,1.21-.87-1.09-.24-2.18-.44-3.27-.66-.3-.06-1,.6-1.33.76s-.76,0-1.15,0a14.3,14.3,0,0,0-2.92-.14c-.63,0-2.46-.26-2.95.2-1.69,1.58-3.35,3.15-5,4.82a33.69,33.69,0,0,1-4.9,3.94c.22.58.62.54,1.13.58s.68,0,.95.61c.06.2.28,1.13.48,1.15,1.31.12,1.41.32,2.06-.95.54-1.07,3.65,1.45,3.49,2.32-.37,2-.83,4-1.27,6.07a13.67,13.67,0,0,1-2.16,4.62,23.65,23.65,0,0,1-3.05,4.28l-2.24,2.2c-.1.12-.22.22-.34.34-.46.46-1.45.46-2.06.61-.3.08-.58-.81-.86-.87s-.93.54-1.13.66c-.95.57-1,.83-1.36,2a7.73,7.73,0,0,1-.32.77c-.06.08-.1.18-.16.26a3.22,3.22,0,0,1-.42.6,6.68,6.68,0,0,1-.61.69l-.66.63-1.15,1.06a9.07,9.07,0,0,1,1.55,1.62h0a3.33,3.33,0,0,1,.36.56,2,2,0,0,1,.22.47,1.63,1.63,0,0,1,.15.4,1.6,1.6,0,0,1,.1.42,3.9,3.9,0,0,1,0,1.28c-.19,1.43,0,1.73-1.19,2.36a4.42,4.42,0,0,1-2.59.44c.1-.81.23-1.61.33-2.42s-.71-.87,0-1.72a.75.75,0,0,0,.18-.78.12.12,0,0,0,0-.14.6.6,0,0,0-.16-.19.55.55,0,0,0-.41-.1c-.6.08-1.57.49-1.77-.46-.1-.48.52-1.65.66-2.14a4.64,4.64,0,0,0-1.11-.76,1.28,1.28,0,0,0-.4-.19c-.48,0-1.39.85-1.81,1.11L388.79,239c-.48-1.21.67-2.1,1.37-2.84-.77-.61-.79-.77-1.61-.37a7.23,7.23,0,0,0-1.48,1,4.7,4.7,0,0,1-1.73,1.11c-.14,0-1.45.51-1.09.91a12.4,12.4,0,0,1,1.39,1.68c.55.88.49.76,1.37.32,1.28-.65,2.26-.1,3.62.26-1.48,1.23-2.95,2.48-4.42,3.73.62.55,1.41,1,1.77,1.8.47,1,.95,2.06,1.39,3.06l-2.28-.42c.81.61,1.62,1.19,2.43,1.78l-1.8,1.27,2.22.66c-.91,1.68-1.7,3.84-2.87,5.31s-2.19,3.35-4,4.09-3.87,1.62-5.83,2.32l-1.82.67c-.5.18-.38.18-.26.76.08.39.08,1.17-.6.83-.18-.1-.39-1-.47-1.23.23,0,.43-.22.65-.26-.69-.53-1.92-.93-2.66-.32s-2.2,1.29-2.46,2.13c-.09.27-.59,1.38-.47,1.6l1.17,1.83a28.78,28.78,0,0,0,1.86,2.49c.78,1,1.23,1.37,1.29,2.68,0,.79.48,2.68-.12,3.23a62.6,62.6,0,0,1-5.15,4.37c-.6-.62.22-1.53-.2-2-.22-.27-.46-.51-.68-.75s-.71-.75-1.05-1.13a4.41,4.41,0,0,0-3.25-1.8l.12-1c-1.37.06-1.11.24-1.23,1.73a9.9,9.9,0,0,1-.81,2.56,1.23,1.23,0,0,0-.06.61c0,.18,0,.36.06.52.06.73.06.61.73.57.34,0,.77,2.18.89,2.58.2.67,1.49,1.27,2,1.65a5.54,5.54,0,0,1,1.5,1.7c.3.79,0,1.89.16,2.72a18.8,18.8,0,0,0,.95,2.34,6.53,6.53,0,0,1-2.83-1.67,3.58,3.58,0,0,1-1.33-2.26c-.26-.79-.48-2.62-1.05-3.21L359.64,284c-.26-.28-.08-1.52.08-2.4a1.35,1.35,0,0,1,0-.29h0c0-.2,0-.38.06-.5a23,23,0,0,0-.22-3.51,25.84,25.84,0,0,0-1.51-6.21c-.45.54-.89,1.07-1.34,1.63s-.5.67-1.35.47-.8-.13-.66-1.09c0-.43.4-1.52.24-1.9-.61-1.37-.93-2.58-2-3.47s-1.31-2.14-1.81-3.31c-.49.34-1.19,1.09-1.78,1.17l-3.06.43c-.15,0-.79,0-.89.12s.12.9-.06,1.11l-1.52,1.55-4.27,4.4a7.8,7.8,0,0,1-2.06,1c-.77.38-.48.94-.46,1.85a10.79,10.79,0,0,1,0,2.66,5.81,5.81,0,0,0-.57,2.51,3,3,0,0,0,.14.5c.06.2.1.38.16.56a2.07,2.07,0,0,0,.21.45,2.28,2.28,0,0,0,.2.38,4.89,4.89,0,0,0,.44.57,8.25,8.25,0,0,1,1.29,2.44c.71,1.63-2.08,3-2.28.85a19.39,19.39,0,0,1-.08-2.85c0-.93-.3-1.09-.91-1.73l0,0c-.08.66,0,1.35-.5,1.71l-1.74,1.15c-1.61-3.07-3-6.21-4.39-9.4a15.54,15.54,0,0,1-1.17-2.68,12.73,12.73,0,0,1-.06-2.14c-.06-2-.12-4.06-.21-6.09-.42.58-.84,1.19-1.27,1.77s-.48.51-1.19.49-1.73-1.56-2.28-2.16c.57-.12,1.76-.06,1.86-.85a3.54,3.54,0,0,1-1,.1,12,12,0,0,1-2.5-1.43c-.52-.3-.87-1.64-1.13-2.2s-4.58.34-5.31.44c-1.59.18-3.2-.44-4.78-.8-.68-.17-1.47-.08-1.81-.77-.65-1.25-.49-1.61-1.74-1.17a4.63,4.63,0,0,1-2.76.06c-.69-.1-1.11-.95-1.74-1.23a2.74,2.74,0,0,1-1.79-1.86c-.36-.78-.5-1.79-1.33-1.93-1.43-.2-1.43-.14-2.42,1-.35.4.84,1.85,1.11,2.28.88,1.49,1.65,3.08,2.46,4.64.12-.71.24-1.42.34-2.12a6.31,6.31,0,0,1,.51,3.33c1-.07,2.76.12,3.71-.47s1.79-2.06,2.54-2.9c.06.88-.14,2.32.58,2.82a8.77,8.77,0,0,0,1.34.91c.4.18.9,0,1.12.48s.47,1.21.83,1.27c.63.12.39.57.32,1.21s-1.37,1.76-1.77,2.24c0-.22-.18-.4-.22-.6a4.26,4.26,0,0,0-.55,2.06c0,.76-.28.68-.92,1s-1.32.63-2,.93c-.39.18-.37,1.29-.75,1.47s-.78-.26-1.11-.12c-.48.23-1,.43-1.45.63-.65.3-.57,1.19-1.17,1.41L298.05,275c-.32.12-.38.28-.58.61s-.61.36-1.05.44c-.95.18-1.88.48-2.81.75-.68.18-.82,1-1.59,1-1.17,0-1.27.27-1.49-.94s-.47-2.46-.69-3.69a14.05,14.05,0,0,0-2.26-4.83c-.58-1-.66-1.15-1.67-1.53-.59-.22-.59-2-.69-2.6a10,10,0,0,0-1.17-2.6c-.26-.51-.83-.75-1.13-1.29-.64-1.17-1.31-2.32-1.95-3.49-.33-.59-.57-1.58-1.34-1.4.08-.7.21-1.43.29-2.14-.29.85-.57,1.72-.85,2.57a11.89,11.89,0,0,1-2.12-3.23c-.68.89.53,2.34.93,3.15l2.38,4.86c.48,1,.3,2.08,1,2.84.3.32,1.07.85,1.15,1.33.12.83.24,1.64.38,2.46.06.49,0,1.4.38,1.76a8.12,8.12,0,0,1,1.46,1.41,19.84,19.84,0,0,1,1.41,3.83c.16.41,1.31.35,1.59.69.45.5.89,1,1.33,1.55.75.85,2.24,1.8,1.09,2.93.77.22,1.62,1.83,2.24,1.67,2.14-.56,4.26-1.15,6.4-1.71.38-.1,1.53-.59,1.85,0,.2.34-.54,2.4-.64,2.82-.39,1.72-1.64,3.33-2.42,4.82a16.37,16.37,0,0,1-2.24,3.68c-2.58,2.72-5.59,5.22-7.51,8.53-.44.73-3.18,4.48-2.74,5.14a3.3,3.3,0,0,1,.69,2.81,2.59,2.59,0,0,0,.74,2.4c1.15,1.57.77,4,.85,6a4.37,4.37,0,0,1-2.28,3.71,8.9,8.9,0,0,0-2.46,1.19l-1.92,2.26c-.56.65-1.25,1-.91,1.82.25.56,1.13,1.89,1.05,2.52s.06,2.44-.32,3-2,.93-2.5,1.19c-.91.45-.71.85-.81,2-.06.59.06,2.2-.28,2.68a47.46,47.46,0,0,1-3.29,4.66,26.52,26.52,0,0,1-2.2,1.9c-.4.34-1.19,1.37-1.73,1.47-1.9.41-3.79.81-5.71,1.19-.87.18-1.76.37-2.62.57-.43.08-1.29-1-1.6-1.31-1-.95-1-.93-.84-2.42.06-.57-.59-1.6-.79-2.1-.44-1.11-.89-2.22-1.33-3.31-.26-.67-1.07-1.17-1.56-1.66-.34-.32-.32-1.85-.4-2.32-.18-1.27-.38-2.54-.56-3.79a15.81,15.81,0,0,0-1.88-4.56c-.48-1-1-2-1.45-3-.22-.45.08-1.25.14-1.72.32-2.16.38-4.21,1.43-6.09s.38-3.23,0-5.1q-.72-3-1.41-6.05a6.52,6.52,0,0,0-1.33-1.82c-.69-.93-1.37-1.86-2.06-2.76-.36-.51-.1-1.15,0-1.78.14-1.25.28-2.5.44-3.77.12-1.07.18-1.13-.44-2s-.69-1.07-1.8-1c-.64,0-2,.45-2.42-.12-.64-.81-1.31-1.61-2-2.44-.29-.34-4.3.3-4.8.55l-2.87,1.45c-.73.4-1.07.2-1.88,0a3.36,3.36,0,0,0-2.21-.2c-1.05.36-2.08.74-3.13,1.11-.49.18-1.05-.49-1.45-.79-1-.73-2-1.45-3-2.16a7.4,7.4,0,0,1-2.66-2.7l-3.81-6.64c-.41-.71-.81-1.41-1.24-2.14-.18-.32.49-1.55.63-1.89.2-.59.87-1.68.73-2.32-.25-1.05-.47-2.1-.71-3.17a10,10,0,0,1-.61-2.7,6.67,6.67,0,0,1,.81-1.48c1.23-2.22,2.44-4.44,3.67-6.65.87-1.56,1.9-2,3.37-3,.77-.48,1.11-.48,1.25-1.43.18-1.17.37-2.34.55-3.51.2-1.37,2.94-1.64,3.49-3,.38-.93.54-2.24,1.49-2.5.24-.08.93,1.21,1.69,1,.33-.06,1.11-.4,1.44-.24.18.1.88.62,1,.52a18.86,18.86,0,0,1,2.26-1.33,17.84,17.84,0,0,1,4.72-1.47,5.08,5.08,0,0,1,1.45-.16,3.54,3.54,0,0,0,1.15.38c.4,0,.76-.46,1.15-.52a4.84,4.84,0,0,1,1.07.06,4,4,0,0,0,2.66-.33c.73-.42,1.39.14,2.16.47-.57,1.23-.69,1.27,0,2.46.28.52-.85,1.35-1.23,1.75.6.55,1.35,1.54,2.12,1.74l3.91,1c1,.26.71,1.39,1.71,1.81s1.7.22,2.51.81c1.13.79,1.73,1,2.46-.44.18-.35-.39-.87-.21-1.17s.45-1.07.71-1.15a5,5,0,0,1,3.15-.23c.28.08,0,.67.4.75.59.12,1.17.22,1.76.36s.5.33.74.81c.12.24.59-.3.79-.24.95.28,1.88.54,2.82.83a2.13,2.13,0,0,0,2.16-.19c1.09-.52,1.19-.68,2.26-.16,1.29.63,3.27.43,3.85-1.21.37-1,2.16-4.13,1.46-5.16-.45-.67.52-2.06.3-2.32s-.63.18-.85.34-.6-.32-.89-.26-.66.83-1,1a4.8,4.8,0,0,1-1.32.06c-.8,0-1.14-.85-1.89-1-.51-.08-.91-.38-1.11.18s-.22.63-.85.75-1.65-.75-2.16-1.05c-.92-.53-2.54-3.23-1.53-4.36l-1,.12c-.14-1.11,1.29-1.41,1.9-1.43a5,5,0,0,0,2.78-.63l-.95-.48c.18-.54,1.36-.3,1.88-.24,1,.14,1-.12,1.8-.65a3.5,3.5,0,0,1,1.79-.78,5.37,5.37,0,0,0,2.26-.08c-.18.32.14.6.48.76.53.26.33-.44.87.32.2.27,1.68.49,2.14.69.81.32,1.31-.16,2.12-.06a3.17,3.17,0,0,0,2.3-.73c.66-.4.3-1.53-.1-2-.59-.65-1.29-.77-1.92-1.36s-1.19-1.41-2.08-1.53a8.06,8.06,0,0,1-.89-.52c-.36-.24-.68-.53-1-.79a4.37,4.37,0,0,1,.28-.4c.32.06.64.14,1,.2-.31-1.07.36-1.39,1.15-1.37a3.47,3.47,0,0,1-1.07-1l1,0c-.25-.75.74-.2.88-.67s-.62-.3-.84-.26c-.83.14-1.72.16-2.28.93v-.28a3.48,3.48,0,0,0-2,1,2.83,2.83,0,0,1,.16-.36c-1-.1-.5,1.07-.14,1.51s1.23.29,2,.29c-.55,1-1.17.24-1.78.56s-1.85,1.45-2.54.89c.42-1.15-.12-1-1.07-1.45.46-.27,2.28-.93,1.05-1.35a3.39,3.39,0,0,0-1.23,0c-.28,0-.69-.43-.93-.61.51,0,1.15.3,1.41-.26-.54.26-1.93-.37-2.28,0s-1.41,1.23-1.49,1.79a4.57,4.57,0,0,1-.22,1.33c-.16.27-.89.23-.95.55-.2,1-.16,1.73-1,2.26s-.6,1.45-.22,2.18c.24.48,1.51,1.07,1.45,1.29-.22.64-1.39-.18-1.79.22L268.9,237c-.08-.69.32-.81.79-1.09-.36-.17-.79-.17-1.21-.33a10.06,10.06,0,0,0-1.62-.26c-.28-.08-.64.16-.92.28s.1.57,0,.69c-.51.42-.87,0-1.32-.28-.48.54.05,1,.33,1.55.42.75.44.67-.16,1.29.78.55,1.65.75,1.49,1.88-.49-.37-.81-.81-1.29-.18.6.12.66.5.22.84s-.22.57,0,1.15c-.52-.12-.93,0-1.17-.56s-.42-.32-.83,0c-.4-1.39-.68-1.51.39-2.38-1,0-1-.12-1.6-1-.34-.51-.58-1.37-1-1.74-.78-.64-.5-1.15-.4-2.22s-.24-1-1-1.57c-1-.77-2.1-1.85-3.31-2-.3,0-1-1-1.13-1.31A2.56,2.56,0,0,0,254,227.9c-.34,1-.74.5-.86-.22s0-.55-.77-.33-1.23.29-.75,1.17c.16.31-.42,1,.1,1.44a6.84,6.84,0,0,1,1.54,1.14c.36.49.3,1.26.74,1.66s.83.85,1.54.89c.44,0,1.23,0,.52.56.65.53,3.85,1.86,3,2.95-.33-.16-1.25-1.44-1.62-1.07a1.34,1.34,0,0,0-.56,1c-.12.46.18.42.5.68.95.73-.62.93-.56,1.37.08.63-1.19,1.72-1.15.71a1.32,1.32,0,0,0-.45,1.76c.31.62-1,.82-1.11.32-.28-.91-3.34-.81-2.13-2.14a5.5,5.5,0,0,0,2.22.26,5.28,5.28,0,0,0,1.57-.36c.4-.26.06-.55.48-.79s-.42-2-.64-2.08-.87,0-.79-.44-.4-.67-.77-.48c.09-.43-.84-1.11-1.21-1-.64.08-1-.57-1.49-1.05-.85-.81-2-1.23-2.26-2.36s-.24-1.13-1.13-1.6c-.46-.24-1.05-.42-1.39,0s-2.64,2.06-3,2l-1.34-.42L241.2,231c-.42-.12-1,.75-1.35,1a.07.07,0,0,0,0,0c-.1.23.31,1.35,0,1.76s-1.39.7-1.81.93c-1.31.68-1.72,1.73-2.48,3.06-.25.41.76.77.28,1.41-.28.41-1.09,1.05-.85,1.56-.28.06-1,.08-1.11.36s-.46,1-.7,1a17.52,17.52,0,0,1-2.51,0c-.72,0-1.17.89-1.75,1.07s-1.47-1-.81-1.47c-.64.3-1-.77-1.77-.31-.65.37-1.11-.2-1.7.25a5.68,5.68,0,0,0,.18-1.44l-.06-.8c0-.29-.3.06-.42-.1-.48-.75-.12-.93.08-1.78s.79-2.08.46-2.86a4,4,0,0,1,0-2.32c-.44.36-.74-.33-.56-.77s1-.4,1.31-.44a2.23,2.23,0,0,0-.14-.27c.79-.7,1.15.25,1.84.08a3.23,3.23,0,0,1,2.25,0c.73.25,1.36-.14,2,.1a3.91,3.91,0,0,0,1.82.21c.8-.19,1-1.23,1.11-2.24,0-.61,0-1.21,0-1.6,0-1,.16-1.29-.75-1.59-.54-.16-.6-1.11-.5-1.41-.49.12-.31-.18-.51-.26a6.44,6.44,0,0,0-.89-.21c-.38-.32-.54-.52-1-.48a.73.73,0,0,1-.81-.4c.14,0,.28-.1.42-.12a.87.87,0,0,1-.54-.79,3.2,3.2,0,0,0,1.63-.28c1-.71.43.54,1.07.38.22,0,1.45-.24,1.39-.59,0-.2-.08-.4-.12-.58l-.18-.46a4.19,4.19,0,0,0-.2-.49c.26,0,.75-.06.85.22a.18.18,0,0,1,0,.1h0a.61.61,0,0,0,.12.29.47.47,0,0,0,.28.1,2.85,2.85,0,0,0,1.73-.24c-.16,0-.32-.15-.48-.17a1.62,1.62,0,0,1,.32-.32,6.23,6.23,0,0,1,1.25-.6c.77-.39,0-.87.35-1.48.16-.28,1.33-.54,1.67-.7a2.69,2.69,0,0,1,1.61-.2c-.24-.09-.86-.15-.86-.43,0-.06.58-.1.62-.16s0-.4.14-.54a3.21,3.21,0,0,0,.63-1.54c.08-.32.6-.26.83-.5.66-.81,1.35-.34,2.16-.61.12,0,0-.42.2-.44s.44-.08.66-.1a3.71,3.71,0,0,1,1,.1c-.12-.63.43-.46.87-.53-.24-.08-.93-.66-.59-.92.55-.43.06-.39-.12-.95s.18-.93-.32-1.33-.3-.57-.34-1.13c0-.93.14-2,1.13-2,.72,0,1.35-.83,2-1.19-.5.73-.74,2.28.33,2.54-.63,1-1.82,1.33-1.62,2.69.18,1,1.09,1.79,2,1.37l-.36.78c.88.53,1.65-.74,2.42-.82a1.59,1.59,0,0,1,1.11.72c.14.51.6.63,1.05.87a1.27,1.27,0,0,0,.08-.48l-.75-.08c.55-.35,2.48-.39,2.87-.89a2.8,2.8,0,0,1,2.69-.83c0,.83,1.16.94,1.58.42.16-.18.24-.68.35-.78s.34,0,.44-.1c.28-.27.66-.41.87-.75a2,2,0,0,1-.55.81c1.41.68.57-1.92.53-2.56a1.91,1.91,0,0,1,.42-1.32c.3-.36.06-.92.56-1.31,1.26-.93,1.56,1.15,2.49,1.21.52,0,.88-.7.8-1.15s.2-1.49.12-1.55-.4.22-.5.14-.36-.4-.57-.58-.38-1.21-.24-1.27a6.06,6.06,0,0,1,2.93-.83l2.16.26c1,.12.16-.24.74-.6.39-.25.95-.11,1.39-.39s1,.1,1.36.14c-.21-.66-1.54-.9-2.12-1.15.1-.14.1-.4.22-.54-2,.38-4.1.89-6.15,1.27-.2.06-1.05.36-1.19.14a1.88,1.88,0,0,0-1.17-1c-.81-.32-.75-.26-.61-1.19a3.12,3.12,0,0,0,0-1.55,6.11,6.11,0,0,1-.46-1.86c.08-.4.91-1,1.17-1.33.64-.75,1.53-1.23,2.16-2,.32-.38.82-1.33,1.25-1.53s1,.2.8-.6a2,2,0,0,0-2.05-1.54c-1.42-.06-1.54-.1-2.51,1-.62.69-.94,1.25-.44,2.14s-3.35,2.76-3.67,3.17c-.95,1.21-2.56,3.12-1.53,4.9.44.74,1.69.72,2.09,1.61.29.61-.76,1.15-1.23,1.54-.78.68-1.39,1-1.55,2a13.14,13.14,0,0,1-.44,3c-.47,1.09-1.27,1.09-2.22,1.29-.37.08-.35.52-.45.91s-.4.32-.84.34c-.67.06-.73.22-.83-.52a3.18,3.18,0,0,1-.12-1.36c.28-.76-.83-1.69-1.27-2.28-.2-.26-.08-.72-.22-1a6.24,6.24,0,0,1-.59-1.22c-.08-.4.26-1.06-.18-1.17s-.42-.74-.57-1.12a2.31,2.31,0,0,1-1.27,1.73c-.58.4-1,1.05-1.63,1.39-.91.57-3.23.28-3.27-1.13-.06-1.75-.75-3.43-.66-5.16.08-1.49.18-1.49,1.27-2.42a8.94,8.94,0,0,1,1.93-1.13,6.25,6.25,0,0,0,2.2-1.41c.59-.65,1.17-1.26,1.8-1.86,1.35-1.27,1.95-2.86,2.94-4.46a30,30,0,0,1,3.41-4.05c1.17-1.31,2.24-2.77,3.79-3.47a46.19,46.19,0,0,1,5.27-1.92c.69-.2,1.05-1.33,1.67-1.69a3.7,3.7,0,0,1,2.18-.39,5,5,0,0,0-1.53,2.63c.79-.17,1.45-1.48,2-2.1.1.38.16.78.24,1.19.36-.49.72-.95,1.07-1.43.14-.21,1.07,0,1.31,0-.22.38-.45.72-.67,1.1.95.71.41-1,1.17-.72s1.62.62,2.42.95-.58.9-.84,1a8.36,8.36,0,0,1-2-.19c.3.55.93.35,1.21,1,.06.16.87-.1,1.17-.08.69.06,1.33.36,1.8-.24.2-.3,1.06.34,1.37.48-.18.65-.79.25-1.23.12-.21,1.34,2.09.83,2.72.85a5.62,5.62,0,0,1,3.07,1,15.75,15.75,0,0,0,3.18,1.53,3.47,3.47,0,0,1,2.38,1.86c.33,1,.29,1-.28,1.86-.34.52-.46.86-1,1a4.11,4.11,0,0,1-2.94.19,26.94,26.94,0,0,1-6.48-2.2c.65.64,2.46,1.85,2.46,2.82s-.16,2.93.73,3.31,2.28,1.57,3.25,1.17c.58-.24.28-1.17-.31-1.17s-.8-.52-1.21-1c.91-.83,1-.62,2.08-.24.91.32,1.82.62,2.72.95a17.54,17.54,0,0,1-.7-2.08l2.06-1.37c.36-.24,1-.93,1.45-.81l2.18.65c.08-.41.42-1.17.28-1.58,0-.1-.75-1.25-.79-1.09.16-.68.33-1.33.47-2,.06-.25-.71-.95-.87-1.13.87.1,1.75.22,2.62.34.67.08,1.09,1.07,1.49,1.61-.42,0-1.71-.08-1.93.33-.38.64.32,1.09.74,1.63s1.13.22,1.8.1c.83-.1.22-.73.67-1.31.2-.26,1-.42,1.25-.57.78-.34,1.57-.7,2.36-1.06l3.61-1.64c.34,1.13.34,1.11,1.39,1.39.69.17,1.05-1.13,1.65-1.07a3.24,3.24,0,0,0,2.22-.14,2.58,2.58,0,0,1,2.2-.18c-.14.26-.3.53-.46.79,1.11.34,1.07.38,1.79-.59s.25-1-.42-1.89a7.72,7.72,0,0,1,5.39.2l3.22,1.29a10.89,10.89,0,0,1,2.24,1.69c.06-.4.47-1.77.14-2-.78-.61-1.59-1.19-2.38-1.8-.52-.38.31-1.49.55-2s-1.05-.9-1.39-1.15l2.34-1.85c.52-.42.74-2,1-2.62.31-.83,4,.06,4.89.14-.35.91-.67,1.83-1,2.74-.18.46.62,1.57.84,2,.39.81-.9,4.38-.26,4.82s1.64.6,1.23,1.57c-.24.55-.5,1.82-1,2.12-.82.51-1.67,1-2.52,1.53-.36.23-1.49-.16-1.93-.22,1.07.89,2.3,1.66,3.73,1.17,1.15-.36,2.44-2,3.29-2.82s-1.5-2.42.5-3c.38-.12,1.47-.7,1.78-.36.5.6,1,1.19,1.53,1.77-.12-.78,0-1.51-.65-2a1.8,1.8,0,0,0-1.87-.47,8.13,8.13,0,0,1-2.26.31c-.14-.55-.63-1.5-.4-2s1-1.51.62-2.14-1.41-1.53-1-2.1c.47-.74,1.19-.86,2-1.19.58-.24.08-1.59-.06-1.93.42-.13,1.25,1,1,1.51-.59,1.13-.53,1.09.1,2.2.4.74,3.49.76,4.27.8a27.27,27.27,0,0,1-3.28-1.35c-1.25-.58.9-1.51,1.41-1.67,1.51-.49,2.14-.12,3.63.44a8.89,8.89,0,0,1,1.31.81c.4.28,1,0,1.43,0a5.82,5.82,0,0,0-.58-1.63c-.31-.29-1.37-.23-1.76-.31s-.6-2.3-.7-2.88l5-.51,2.86-.3c.63-.06.39-.73.41-1.37,0-1.25-.06-1.25.91-1.84a16.61,16.61,0,0,1,2.13-1.27,35.63,35.63,0,0,1,5.11-1,48.61,48.61,0,0,0,9-2c.69-.27.39-1.4.93-1.68.89-.44,1.76-.89,2.63-1.33,1-.54,2.92-.54,3.69.59-.83.26-1.66.5-2.46.74l3.89.57-1.59,1.41c.7,0,1.43.08,2.15.14,0-.28-.12-1.37.15-1.35l1.69.06a4.5,4.5,0,0,1,2.52.34,10.76,10.76,0,0,1,2.52,1.76c.14.18.87.93.77,1.13s-.34,1.09-.59,1.25l-10.47,6.43,7.27-2.05-1.86-.29c.75-.62,1.88-1.23,2.76-.56,1.34,1,1.64.91,3.23.76a31.64,31.64,0,0,1,6.28.47c-.41.22-.81.46-1.19.7.5.25,1.43.95,2,.93l2.5-.12c.49,0,1.86.22,1.94-.42.18-1.27.06-1.23,1.19-1.25a13.48,13.48,0,0,0,2.38-.06c.57-.1,1.78-.63,2.34-.45s1.29,1.48,1.7,1.94c.24.28-.29,1.82-.31,2.24a7.54,7.54,0,0,0,.31,2.36c.76.44,1.51.87,2.28,1.29.34.2,1.35-1.51,1.59-1.84.64-.86.52-1,1.41-.4s1.09.89,2.1.57c.62-.21,1.39-.69,2-.37.44.24,1.45,1.05,1.95.85.77-.32,1.54-.65,2.34-1-.22-.4-1-1.25-.68-1.63s.95-1.62,1.29-1.58l4.5.59a23.68,23.68,0,0,1,3.41.87,16.78,16.78,0,0,1,3.91,1c.67.36,2.16,2.82,2.82,2.7,1.5-.24,3-.51,4.5-.77,1.23-.2,2.4.38,3.59.73.73.22,1.07.1,1.31.89a2.33,2.33,0,0,1,0,1.83c1.28.4,2.24.89,3.53.67a9.55,9.55,0,0,1,4-.08c.54.08,1.29.42,1.77.06.75-.55.65-.57,1.29.08.49.46,1.15,1.45,1.74,1.69.42.18,1.33-.14,1.78-.18-.15-1-.29-2-.43-3,2.16.17,4.3.33,6.44.51,1.67.12,3.28,1.29,4.82,2,1.75.84,3.45,1.75,5.14,2.74,1.05.59,1.21.65,1.66,1.86s.36,1.77,1.69,1.77l-.48-1.63a8.73,8.73,0,0,1,3.28.5A9.15,9.15,0,0,1,475.84,187.07Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.7,211a1.48,1.48,0,0,0-.53-.22s0,0,0,0C259.32,210.85,259.62,210.93,259.7,211Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.79,219.26c0,.25.44.33.63.43s.18.68.2,1c.44-.13,1.91-.67,2.28-.27s.54.55.44,1.25c0,.25.71.43.81.85.14.65.58,2,.2,2.62s-.47.51-1,.29-.61-.29-.44-1.11c-1.11.08-1.32.8-2.38,1a.81.81,0,0,1,.62-.87,5.9,5.9,0,0,0-3.53-.47c-.36,0-1.27.17-1.53-.26a2.55,2.55,0,0,1,.16-1.59,9.68,9.68,0,0,0,2.34-3.47c.38-.93,1.51-2.34,2.56-1.92-.16.36-.34.73-.5,1.09C165,218.36,164.77,218.44,164.79,219.26Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.85,303.16c0,.24-.1.49-.1.73-1.19-1.13-2.28-2.26-3.33-3.43a7.37,7.37,0,0,1-1.43-1.82,12.34,12.34,0,0,0-1.31-2.9c-.27-.26-.63-.12-.75-.51-.14-.58-.3-1.15-.44-1.71-.27-1-1.5-.77-1.54-1.82s-1.13-1.15-1.63-1.61c-.24-.18-1.55-1.84-1.27-2.24.16-.24,1.81.4,2.16.43,1.09.14.93.56,1.51,1.39a15.14,15.14,0,0,0,1.82,1.67c.64.61,1.43.83,1.95,1.55.26.39.59.35,1,.41.75.14.24.26.67.58s.66,0,.66.69c0,.34.77.28.89.87.08.38-.38.54-.3,1.07,0,.32.72.44,1,.54s.26,1,.32,1.25c.08.49.64.46.06,1.05a1,1,0,0,1,1.69,1c-.32,1-.1,2.32-.3,3.35C368.76,302.84,368.41,303.87,367.85,303.16Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.17,212.1l-.22,0a.77.77,0,0,1,.48-.66A.51.51,0,0,1,230.17,212.1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.41,169.21a.86.86,0,0,1,.22-1.61l1.45.55c.41.14,1-.17,1.34,0a6.57,6.57,0,0,1,2.62,2.09,8.72,8.72,0,0,0-2-.08c-.48.1-1.86.71-2.28.45a3.17,3.17,0,0,1-.87-.53C134.53,169.68,135,169.5,134.41,169.21Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.14,269.78c-.29-.85,2.05.1,2.62-.31-.59-.86-.49-1.15-1.41-1.59.9-.42,1.15-.12,2.07-.12a2.52,2.52,0,0,0,.83-.2c.3-.18.81.16,1.13.26s.42-.18.67.28c.32.63.36.63,1,.75.27.06.85.4.69.68-.4.65-.28.17-.85.17-.76,0-1.23.22-1.91.24-.12,0-.22-.39-.61-.1-.22.14-.22,1-.44,1.05-.53.18-.45-.71-.65-.81s-.72,0-1,0C143.27,269.92,142.92,270.34,142.14,269.78Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.74,177.51l-.12-.39a1.41,1.41,0,0,1,.58,0C262.25,177.57,262.08,177.75,261.74,177.51Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.09,182.27c0-.12,0-.25,0-.37.24-.22.46-.26.66,0A.59.59,0,0,1,253.09,182.27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.05,172.6a3.55,3.55,0,0,1-.65.12c-.14-.66.42-1.12.79-1.59s-.41-.95.7-1c0,0,0,0,0,0-.56-.54.43-1.49.85-1.89.22-.19-.73-1.46-1-1.84,1.27-.18,2.54-.34,3.79-.54.83-.11,1.64.68,2.51.88v0a1.11,1.11,0,0,0,.72,0,4.7,4.7,0,0,1-.12.51c.85-.95,1.92-.55,2.89-.14a6.79,6.79,0,0,1,1.35.88c.62.43.66.69.12,1.17-.85.75-2.44,1.07-3.45,1.52-.46.2-.73.18-.87.7s-.74,1-1.31.69L84,173.67a8.18,8.18,0,0,1-1.17.55c-.14,0-.08-.35-.24-.26s-.39.22-.57.34c-1.21.68-1.09.7-2-.39A5.53,5.53,0,0,0,78.05,172.6Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.75,266.77c0-.52-.77-.32-1-.42-.79-.37-.81-1.19-1.51-1.29s-1.42-.61-2.14-.65c-.43,0-.47-.32-.87-.2a.92.92,0,0,1-.95-.34.78.78,0,0,0,.67-.13c-1.29-1.31-2.77,1.64-4.08.95.67-.42.89-1.21,1.7-1.41a7.74,7.74,0,0,1,2.84-.38,11,11,0,0,1,4.86,2.1,1.39,1.39,0,0,1,.1-.21,2.55,2.55,0,0,0,2.08,1c.16,0,.36.55.73.61a2.77,2.77,0,0,1,1.21.72c-.51.17-1,.33-1.54.45-1-.08-1.95.16-2.92,0C138.08,267.44,138.75,267,138.75,266.77Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.93,207.22c.18-.22.59-.36.63-.52a1.48,1.48,0,0,1,.44-.87,1.76,1.76,0,0,0-.3-.1l.2-.1c-.22-.08-.38-.06-.32-.39l.34.08c-.12-.2-.14-.48-.26-.68a.87.87,0,0,1,.88.08c-.16-.14-.3-.36-.46-.53a2.26,2.26,0,0,0,.12-.32l.39-.06c-.21-.46.28-.95.38-.38.4-.18.1-.14.36,0a3,3,0,0,1,1.82-.35c-.16.85-1.21,1-1.31,1.54a3.08,3.08,0,0,1-.43,0,3.52,3.52,0,0,1,.61.18c-.2.12-.31.38-.47.54l.12.11c.27-.53,2.57-.81,2.91-.29.52.81-1.47,1.88-1.05,2.79a.86.86,0,0,0-.91.36c1.41.2,2.06.32,2.54,1.88.37,1.23,1.62,1.35,1.86,2.82a.69.69,0,0,0-.89-.28c.57,0,1.72,1,1,1.53.18.2,2.16-.58,2,.59s-.69,1.45-1.54,2.07c.35,0,2,.39.93.85a12.72,12.72,0,0,1-2.24.53c-.48.12-.56-.35-1-.37s-.93.47-1.22.61c-1,.48-1.21-.63-1.77.74-1-.7-1.72.73-2.42.23.38-.43,1.27-.87,1.41-1.42.26-1,1.09-.66,1.88-.56a2,2,0,0,1,.56-.91l-1.23.42c-.1,0-.68-.32-.91-.32l.21-.16c-.57-.32-1,.52-1.44-.12a2.31,2.31,0,0,0,0-.32c.33-.12,1.17-.29,1.37-.57.39-.54.06-.7.15-1.27-.29,0-.57.1-.87.16.44-.3.68-.68.2-1.07a.49.49,0,0,1,.69.31c.38-.31.74-.13,1.19,0a2,2,0,0,1-.08-.31c.22.12.16,0,.34.22l.14,0a1.41,1.41,0,0,1-.1-1.65c-.73.54-1.33-1.27-.18-1.55-.67-.08-1.27.54-1.76.22.18.54-.3.14-.6,0a2.68,2.68,0,0,0,0,.4c-.67-.5-.1-.58.08-1.15s.1-.4,0-.88-.14-.49.2-.51a3.09,3.09,0,0,0-.14-.46c-.43.88-.93.38-.32-.12-.53.2-.51.68-.57,1.11,0,.28.06,1.17-.36.78-.2-.18,0-.3.1-.54.18-.49,0-.49,0-.87.14-.54.22-1.13.74-1.41-.06-.06-.08-.12-.14-.16-.3.28-.52.64-.88.52.48.4-.27.69-.59.38C228.5,207.56,228.48,207.34,227.93,207.22Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.42,209.48a.87.87,0,0,1-.22-.57C229.5,209,229.59,209.2,229.42,209.48Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.52,160.3c.93.36.51.83,1.68.6.62-.1,1.25.73,1.73,1.11a3.24,3.24,0,0,1-.36.2c.74-.06.85-.14,1.05.69.08.36,1.37.22,1.67.24.63,0,1.31.39,1.41-.34.06-.36-1.15-.65-1.43-.79l.93-.36-1.37-.85a5,5,0,0,0,.58-.52c.16-.18.33-.36.49-.57h0c.06-.1.14-.2.22-.32a.87.87,0,0,1,.64-.08.67.67,0,0,1,.31.48c0,.06,0,.15.06.23l.06.24a.6.6,0,0,0,.08.2.72.72,0,0,0,.24.36c.3.24.38.89.73,1,.54.16.76.26,1,.91.48-.63-.55-1,.7-1.17,1-.14,1.11.6.93,1.37s-.4,1.35-1,1.35h-1.35c-.42,0-.46.47-.73.49-.52,0-.82-.49-1.37-.31-1,.35-1.88.71-2.82,1-1.7.63-2.34.95-3.92-.08,1.29-.44,3.21-.6,4.14-1.59-.49.34-1.6.66-1.88,0-.06.64-1.13.44-1.59.48.1-.5.34-.95-.24-1.15-.27,1-.41,1-1.21,1.52-.1-.63-.85-.75-.61-.08-.32-.07-.64-.17-1-.27,0-.12.06-.24.1-.36a2.81,2.81,0,0,1-1.85-.14c.54-1.07,2.38-.53,3.27-1.25-.31.06-2.61.76-2.69.14s2.69-.53,3-.73c-.69,0-1.74.29-2.34-.06v-.46a4.69,4.69,0,0,1,2.5-.2c-.28-.08-1.43-.23-1.43-.57S91.34,160.24,91.52,160.3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421,360.25a2.46,2.46,0,0,1-2.24-1.73,7,7,0,0,1-.41-3.31c.69.3,1.37.62,2.06.93.36.16,1.53-.59,1.92-.73C423.69,355.85,422.36,360.51,421,360.25Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.68,273.13c.12-.47-.3-.59-.24-1,.14-.77.26-1.56.38-2.32.06-.31.61-.49.87-.45.83.18.4.67,1.35.2.3.65-.24.87-.14,1.34.18.86.54.44.22,1.45a3.42,3.42,0,0,1-.22.79c-.12.18-.59-.17-.57.16,0,.84-.56.54-.1,1.47.25.48,0,1.11.65,1.15.22,0,.28-.51.6-.42a1.82,1.82,0,0,1,.73.26,3.49,3.49,0,0,0,.77.46c.2.06.24-.5.48-.24.53.54.1.87-.5.56,0,.81.84.57.44,1.44-.24-.16-1-.51-1-.79,0-.83-.14-.73-.85-1,0,.34-.1.67-.16,1a1.92,1.92,0,0,0-.6-.69c-.71-.42-.51,0-1.07,0s-1.19-.84-.38-1.27c-.39-.14-1-.18-1.09-.66s-.47-1.43-.17-2C387.28,272.78,387.48,272.94,387.68,273.13Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.81,216.12a2.78,2.78,0,0,0,.64-.33c-.2,0-.4-.14-.6-.18a1.21,1.21,0,0,0,.82-.54c.21-.3.91-.3,1.26-.37a2.57,2.57,0,0,0-1.52.17,8.27,8.27,0,0,1,1.19-1.27,3.65,3.65,0,0,1-1.47-.45c.18-.18.63-.46.54-.73-.16-.56-.3-.62.19-.9.26-.14.66.08.94.16.45.1.63-.18,1-.47l-.84-.3c.42-.72,1.29-1.71,2.17-1.19l-.18.32c.26-.06,1-.38,1.17-.16.3.37.43,1.09.83,1-.08,1-.34,1-1.11,1.55a2,2,0,0,1,.48,1.64c-.12.42-.26.85-.38,1.27s-.42.12-.81.24c-1.11.3-2.68,2.12-3.83,1.13.14-.08.22-.26.36-.34C223.39,216.26,223.11,216.2,222.81,216.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.66,163c.63-.62-.36-1.43-.72-1.85-.61-.73-1-.41-1.86-.31s-1.45.31-2.24-.48-1.19-1.33.06-1.68a6.18,6.18,0,0,1,2.48.27c.71.1,1.07.78,1.84.92s1.53-.48,2.26,0c.4.27.14.55.7.71.41.12.81.24,1.21.34-.16.67-1.57.1-1.45.57,0,0,1.45.85,1.64,1l1,.66c.18.12.6-.3.82-.32a8.65,8.65,0,0,1,2.44.52,3.47,3.47,0,0,1-.42-.34,14.68,14.68,0,0,0,2-.56c.72-.25,1.27.1,1.93-.12,1.56-.53,3.07.28,4.28,1.31-.3.22-.6.46-.93.68a1.93,1.93,0,0,1,1.11.45c-.68.22-.93.16-1.13.88-.1.35-1.55.37-1.85.41a2.57,2.57,0,0,1-1.42-.26c-.58-.23-.14-1.09-.94-1.09.06.32.1.64.16.94-.59.1-1.78.65-2-.2-.22.85-1.27.63-1.69.06a5.24,5.24,0,0,1,0,.57c-.77,0-1.56-.08-2.32-.1s0-.89-.73-1.17a5.14,5.14,0,0,0-.14.8c-.08-.18-.28-.3-.38-.48-.13.79-.59.58-1.13.52s-.63-.16-.93-.8c-.38.28-1.23.86-1.51.22C119.5,164.11,119.28,164,119.66,163Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.77,208.77a2,2,0,0,1,.42-.3c.18.34.14.61-.18.71C227.89,209,228.11,208.85,227.77,208.77Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,145.35c-.7-.32-1.39-.65-2.09-1,1.08-.6,2.38-1.31,3.4-.4.79-1.76,2.79-.89,4.28-1l-1.19-.57c.57,0,1.13,0,1.7,0-.11-.3-.23-.6-.35-.88.51,0,1.25-.14,1.68.16a8.7,8.7,0,0,0,2,1.27l4.44,1.11-4-2.18c.44-.38,1.09-1.21,1.67-1.25s1.05-.08,1.57-.1.45-.47.77-.59a5.39,5.39,0,0,1,2.2.41l2.38,1c-.66-.57-1.35-1.11-2-1.68l3.41.06c.79,0,1.66.93,2.32,1.37-.2-.38-.38-.74-.56-1.13a38.51,38.51,0,0,1,4.23-.62,32.87,32.87,0,0,1,4.42.62l-2.32,1.31a10.58,10.58,0,0,1,4.16-.5,30.14,30.14,0,0,1,4.72,1.25c-1.17.63-2.81,2-4.12,2.1-1.81.12-3.63.26-5.44.4l2.46.43-4.24,1.25,7-1.4c-.08,1.13-3.13,1.92-4.07,2.51a10,10,0,0,1-2.42,1.47c-.91.2-1.82.38-2.73.56l1.7.08a5,5,0,0,1-1.72,1.38c-.54.28-1.29-.14-1.83-.29l.24.85c-1.56.3-3.13.47-4.7.65.64.06,3.12-.25,2.92.8h-2.6c.63.16,2.6.23,2.52,1.15l-2.26.31,1.29.68a2.72,2.72,0,0,1-1.71,1.27c-.45.16-1.47-.5-1.74-.28s.83.65.06,1.31c-.24.22-1.61,1.21-1.33,1.64s.33.32.81,0,.48-.06.91.18c.24.14.18.72.22,1s-.59.34-.77.4-.5-.26-.58-.22-.32.48-.55.56l-2.26.69c.17-.67.39-.89-.14-1.29-.34-.31-.62.42-1.17-.14-.06,1-1.25.46-1.53-.17.16.81-.54.51-.95.37s-.64.44-1.31.44a15.67,15.67,0,0,1-1.67-.14c-.57-.06-1.09.4-1.23-.44-.33,1-1.48.36-1.52-.51-.48.57-.66,1.09-1.23.37.43-.29-.12-.55.08-.79s.93-.4,1.23-.55c.87-.36,1.29-.14,2-.88-1-.1-1-.21-1.57-1.19a3.67,3.67,0,0,1,2.18-.14c.64.1.7,1.1,1.43,1.31,1.81.46,2.48-.57,3.51-2-.63.66-1.9,2.26-3,1.49-1.35-1-.22-1.71.2-3-.58.54-1.19,1.55-2,1.37-1.13-.24-2.22-.32-1-1.51s3.63-1.07,5.06-.31a7.52,7.52,0,0,0-2.26-2.72c-1-.69-2.8-.57-1.87-2.38,0,.08,3.06.08,3.24.14,1.07.28,2.26,1.37,3.23,2-.76-.71-1.53-1.42-2.3-2.1,2.3-.42,4.54-.91,6.8-1.49L137,146.7c.57-.5,1.13-1,1.7-1.53a10.12,10.12,0,0,0-3.35,2.06c-.35.32-1.41.3-1.84.38l-2.12.4c.43-.36.87-.7,1.29-1.07-.58.16-1.15.35-1.71.53.14-.14.24-.34.38-.49-.24.08-1,.17-1.07.45-.08.8-.16.64-.88.64a20.15,20.15,0,0,1-2.67-.28,6.06,6.06,0,0,1,2.85-1.55,5.12,5.12,0,0,0-3.17,1c-1,.64-2,0-3.07-.33a6.76,6.76,0,0,1,2.67-.52,6.82,6.82,0,0,0,2.84-1,17.43,17.43,0,0,1-3.33.75c-1.21,0-2.3.64-3.33-.1l1.82-1.54Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.21,175.93c0-.22-.44-1.61-.3-1.67.5-.22,1.29-.79,1.83-.77l2.3.12c.59,0,.93.51,1.37.91-.76.87-1.63.85-2.72,1-.32.08-.6-.18-.95-.08C462.24,175.65,461.73,175.79,461.21,175.93Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.86,177.59l-5,3c-1.31.81-3.11,1-4.56,1.35l-3.05.83c-.66.16-.85.55-1.31,1.13a12.09,12.09,0,0,1-1.82,2.26,9.53,9.53,0,0,1-2.28.75c-1.08.36-2.15.7-3.24,1.07-.81.26-.79.28-1.11,1.17-.61,1.65-1.19,3.28-1.72,5-.68,2.08-1.35,4.17-2,6.25,0,.18-1.54.14-1.8.06-1.09-.4-2.16-.78-3.23-1.19-.52-.2-1.47-.3-1.81-.83-.67-1-1.35-2.09-2-3.16a27,27,0,0,1-3.15-5.47c-.44-1.25-.89-2.5-1.33-3.77-.3-.85.18-2.36.3-3.25,0-.16,0-1,.17-1.09.62-.24,1.23-.52,1.83-.77.18-.08,1-.28,1-.5l.24-2-2.64.79c-1.21.36-1.15.38-2.06-.63-.72-.78-.28-1.37,0-2.44s-.62-1.51-1.33-2.26-.14-1.31.18-2.25.2-1.11-.24-2.1a23.24,23.24,0,0,0-2.66-5.21c-.29-.36-1.19-2-1.64-2.08l-2.66-.44a16.39,16.39,0,0,0-5-.42l-2.91.36c-.48.06-1.69-1-2.12-1.23L146.33,159c-.62-.39-1.17-1.58-1.61-2.16-.14-.2-.83-.89-.77-1.15s.06-1.25.42-1.35l4.4-1.25a13.48,13.48,0,0,1,3.25-.65c.79,0,.91.12,1.21-.66s.57-1.42.83-2.12c-1.27-.14-2.4,0-3.33-1,2.5-1.29,5-2.58,7.54-3.9,1-.5,2-1,3-1.57a9.84,9.84,0,0,1,2.76-.38l5.39-.71a9.87,9.87,0,0,1,2.74-.36,49.4,49.4,0,0,1,7.43,2.18c-.89-1.5-2.44-2.16-3.84-3.05,1.48-.68,3-1.35,4.44-2,1-.46,2.28.1,3.35.29.89.14,1.76.3,2.64.46.69.12.75-1.09,1.27-1.39A4.6,4.6,0,0,1,189,138c1.11-.1,2.2-.18,3.29-.29a40.49,40.49,0,0,1,9,.73c2.75.38,5,1.55,7.61,2.68-1.33.49-2.64,1-4,1.44.83.66,1.76.46,2.73.5,1.13,0-.45,2.5-.57,2.74.81-.34,2.48-1.51,3.33-1.37s1.47.26,2.2.37.89-.59,1.27-1.09c.63-.75,2.44-.57,3.33-.41a22,22,0,0,1,3.67,1.44c-1,.62-2.12,1.23-3.19,1.85a9.17,9.17,0,0,1-2.86.71c.26.24.52.46.81.68a11.87,11.87,0,0,1-2.38,2.12c-.83.59-1.84,1-2.39,1.86s-1.73,2-1.33,3c.53,1.27,1.21,1.56,2.28,2.28l-3,3c.7.48,1.39,1,2.09,1.43s.49,1.45.61,2.12c0,.3.52,2.06.34,2.28-.7.76-1.41,1.53-2.1,2.3-1,1.15-1.35,3-1.87,4.54-.2.58.4,2,.54,2.56C208.69,176.66,208.63,176.64,207.86,177.59Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.58,150c.12-.3.45-1.41.71-1.47s1.39-.2,1.47-.49c.2-.82.12-1.05.85-1.27s1.27-.4,1.91-.58-.06-.75.89-.71,2.12,1.43,2.83,1.94c-1.09.32-1.09.18-.87,1.41.1.56,1.27.52,1.75.65l-1,1.08c1-.4,1.58-.86,2.57-.32.44.24,0,.85-.18,1.29s.26,1.07.36,1.41a3.37,3.37,0,0,1-2.58.15,5.22,5.22,0,0,0-2.95-.29c-1,.1-1.39-1-2-1.79-.48-.65-1.91-.18-2.64-.14C351.47,150.7,350.52,150.11,350.58,150Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.57,216.32a7,7,0,0,0,.3-2.18c-.14-.5-.26-.57.12-.87s.43.1.63-.08c.48-.44.2-1.15-.24-1.59,1.17-.89.76.91,1.09,1.55.62,1.21-.33,1.82-.12,3,.06.38.5.68.6,1.07l.42,1.67a12.35,12.35,0,0,0,1.15,3.17c-.72,0-.64-1.27-1.37-1.13-1.13.22-1,.54-1.39,1.73-.28.87,0,1,.46,1.8.35.6,1.09,1.61.49,2.26,0-.55-.28-1.35-.93-1.25s-.64.95-.77,1.49a4.26,4.26,0,0,1-.22-2.18c0-.32-.26-.77-.08-1.05a1.23,1.23,0,0,0,.22-1.23c-.2-1-.58-1.05-.1-2.06a5.35,5.35,0,0,0,.28-2.5C415.74,217.31,414.47,217,414.57,216.32Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.38,148.21c-.54-.16-1.09-.3-1.63-.44,1.59-.48,2.66-1,4.25-.58a4.5,4.5,0,0,0,2.22-.35c.79-.2,1.21.18,1.88.63-1.19.26-2.38.54-3.57.83.1.34.18.66.28,1a7.91,7.91,0,0,1-3-.48c.59-.38,1.19-.81,1.8-1.21Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.24,352.36c-.14.15.18.67-.22.49s-1-.12-1,.46c0,.95-.75,1.94-1.15,2.77s-1.21.62-1.85.22c.34-.39,1.21-1.29.84-2-.12-.22-.78-.24-1-.36a8.44,8.44,0,0,1-.9-.81,2.87,2.87,0,0,0,1.23-1.73c.26-.67-.22-1.34,0-2-.67.22-1.27-2-1.56-2.56a2.86,2.86,0,0,0-.3.22c-.26-.57-.52-1.11-.81-1.68.51.15.77.67,1.32.87,1,.41.5.28.8,1.27a3.06,3.06,0,0,0,.51.71c.18.26-.06.68.08,1,.44.9.93.32.85-.41.72.35.26,1.66,1,1.84,1.15.3,1.35.38,2.36-.28C461.47,350.45,460.69,351.94,460.24,352.36Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.75,307.1c-.64.58-2,.2-2.76.22-.36,0-.63.56-1.19.46-.26,0-.32.22-.55.26s-.36-.36-.82,0c-.27-.28-2-.1-1.34-.82s1.78.4,2.37.06c.28-.16.58.3.82.1.45-.4.51-.45,1.05-.4C392.26,307.06,392.82,306.75,393.75,307.1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.05,178.51a4.43,4.43,0,0,0-.51-.06c.37.37.26.79.24,1.27.49-.46.93-.86,1.64-.68-.43.6.22.5.22,1,0,.28-1,.6-1.31.62-1,.12-2-.46-3-.46.12-.08.22-.2.35-.28l-1.84-.37c.08-.16.06-.38.14-.54-.52-.16-.54.3-.91.6a2,2,0,0,1-1.19.51c-.86.14-1.19.76-2.07.82-1.28.11-2.57.19-3.84.31-1,.06-1.31-.53-1.19-1.68-1.81-.08-4,.29-4.66-2,1.13-.25,2.58-.87,3.73-.73a16.83,16.83,0,0,0,2.2.3c.33,0,1.86-.28.91-.52A14,14,0,0,0,91,176c-1,0-1.9,0-2.85,0-.72,0-.88-.32-1.45-.86,1-.43,1.88-.83,2.81-1.26l-2.69.09a4.19,4.19,0,0,1,.2-.49H85.79c-.14-.85.69-1.29,1.19-1.75-.2,0-.38-.25-.56-.29a12,12,0,0,1,3.79-2.05c.73-.27,1-.53,1.65-.17.89.53.25,1.19-.36,1.7.39,0,.75-.06,1.13-.1s.47-.79.77-.87c.46-.12,1.79.83,2.26,1.07-.18.22-.35.46-.53.71.69,0,.73.06,1.09-.59.14-.24,1,.14,1.31.22l-1.19-1.25C97,170,98.64,170,99,171c.22.69.46,1.37.7,2.06s.49.24,1,0c-.28-.75-.54-1.49-.81-2.24-.12-.32-.24-.67-.34-1s.44-.46.14-1c.26.12,1.13.77,1.29.51.37-.55.79.14,1.27.42,1.13.63,1.46,2.48,2,3.71.2.53-.24,1.13-.08,1.49s1.41.89,1.76,1.09a4.46,4.46,0,0,0,2.76,1c.06.55.16,2.14-.63.93,0,.16-.2.28-.24.44-.54-.46-1.11-.74-1.27.31A1.87,1.87,0,0,1,106.05,178.51Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.36,293.72c-.7-.68-.5-.66,0-1.53.41-.67,1-.67,1.72-.91s.86-.83,1.23-1.39c.54-.83.68-.83,1.61-1.07.73-.18.28-.63.79-1.21.28-.32,1.15-1.7,1.55-1.76s1.31.89,1.56,1.21.42.73.7.79.61,0,.75.45l-1.31.36c.18.26.36.5.52.74-.32.09-1.47.07-1.49.63a2.8,2.8,0,0,0,.08.81c.1.42.36.6.6,1.29.06.18-.2.52-.12.68s.59.53.79.73c.85.77.42.91-.48.71-.45-.1-.81.8-.77,1.31.06,1.09.08,1.09-.71,1.77-.58.51-.78.53-.78,1.31s0,1.66-.06,2.51c-.41,0-.43-.31-.31-.69l-1.75.87c-.06-.29-.1-.91-.39-1s-.64.06-.82,0c-1.07-.67-1.19-.43-2.3.2-.06-.32-.1-.67-.16-1-.37.16-1.8.75-1.86,0s0-2.08-.64-2.64c-.11.38-.05.2-.45.4.12-.56-.08-.26-.16-.58a.37.37,0,0,1,0-.14c-.06-.21-.12-.39-.18-.57s.24-.3.2-.46-.44-.53-.4-.83c.06-.5.12-1,.18-1.49.28-.18.54-.35.82-.51C374.41,293.6,375.72,293.56,376.36,293.72Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.29,297.33c.22-.66,1-1,.48-1.77a3.61,3.61,0,0,1,1.33-1.74c.57-.36,1.64.26,2.2.47s.41-.14.79-.1.81.34,1.09.16c.52-.35,1-1.25,1.59-1.27-.44,1.23-1.25,2.8-2.64,2-.59-.32-1.41-.06-2,0s-1.09-.52-1.49,0c-.85,1,.3,3.15,1.41,2,.45-.5.2,0,.65-.08s.4-.3.88-.32,1.23-.61,1,.4c-1-.67-1.43,1.63-2.58,1.21.32.36.59.34.85.83.14.3.3.58.46.88s-.32.51-.26.67c.26.61,1.09.22.79,1,0-.18-1.09.7-.93.7-.49.11-.89,0-.71-.66s-.54-.51-.74-1.11c-.06-.26.38-1.31-.19-1.25-1,.12-.32.46-.38,1s.06,1.15,0,1.61c0,.24-.26.45-.28.69s.28.68.18.82c-.16.35-1.17.21-1.35-.08a7.65,7.65,0,0,1,.32-2.13c.12-.93-.54-.41-.81-.79-.48-.71-.28-.81.11-1.59C386.25,298.22,386.11,297.86,386.29,297.33Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.94,313.87c.3,1.46.77,2.59.2,4l-.64-.65a9.66,9.66,0,0,1-.49,4.3c-.77,2.5-1.51,5-2.26,7.54-.22.69-.42,1.4-.62,2.08,0,.08-1.66.57-1.88.69s-1.86-.43-1.9-.77a24.67,24.67,0,0,0-.5-2.7,4.18,4.18,0,0,1-.16-2.66c.26-.83,1.23-1.68,1.31-2.53a9.81,9.81,0,0,0-.63-2.82c-.1-.44.31-2.1.67-2.16a8.08,8.08,0,0,0,2.52-.93c.81-.4,1.11-1.09,1.72-1.79.78-.89,1.13-.89,1.17-2.14.08-1.57,1.13.06,1.45.5Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.43,159.83c.26-.16.81.21,1.07.31a2.24,2.24,0,0,1,.57,1c0,.33-.17.71-.14,1.07s.34.55.22,1c-.12-.12-.31-.16-.43-.28a.79.79,0,0,1-.32.73c.22.1.38.34.61.44-.59.57-1.5.26-2.18.22-.22,0-.35.39-.61.31-.44-.15-.89-.11-1-.67.21,0,.45-.12.65-.08a2.61,2.61,0,0,0-1-.26.86.86,0,0,1,.87-.37l-.2-.18a.62.62,0,0,0,.68-.42c-.84.1-1.71.18-2.56.36-.54.12-2.14.06-1-.72h-1.07a1.09,1.09,0,0,1,.83-.39c.52-.1,1.53.41,1.69-.16-.62.18-.74-.42-.16-.65-.24,0-.5,0-.76,0-.12-1.75,2.54.79,2.9,1-.28-.36-.54-.72-.81-1.09.19,0,.39-.06.59,0-.12-.48-1.86-.56-.81-1S110.67,160.32,111.43,159.83Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.26,304.88l-1.13.12c.1.28.2.89.42,1.05s.77.36.91.64c.54,1.13.5,1.44,1.65,1.48-.32.74.37.66.85.76-.48.43.54,1.13.87,1.47-.45.15-1.27-.48-1.8-.58-.77-.14-1.51-.06-2.08-.67s-1.43-1.49-2.13-2.26c-.37-.38-1.88-.3-2.39-.36s-.62,1.35-1.06,1.66a4.07,4.07,0,0,1-2.63.22c-.56,0-.9-1.41-1.37-1.37l-2.68.28c.16-1.33.26-1.19,1.43-1.54-.32-.78-.64-1.59-1-2.4-.2-.46-1.25-.66-1.65-.82l-3-1.27c-.84-.37-.82-.33-1-1.33-.36.42-.7.84-1.05,1.27-.4-.67-.78-1.34-1.19-2a3.84,3.84,0,0,1,2.41-.1,1.49,1.49,0,0,0,.06-.59,4.16,4.16,0,0,1-2.3-.12c-.27-.14,0-.78-.27-.83l-1.19-.18a2.43,2.43,0,0,1,2.95-1.19c.73.18,1,0,1.07.85a7.46,7.46,0,0,0,.54,2.06c.24.64.55.68,1.15,1,.22.1,1-1.15,1.15-1.38a2.37,2.37,0,0,1,2.3-.9c1.45.54,2.89,1.11,4.34,1.65a16,16,0,0,1,2.84,1.09c.55.34,1.11.71,1.68,1s.3,1.07.7,1.51C420.3,303.77,422.4,303.26,422.26,304.88Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.13,231.39a1.36,1.36,0,0,0,.14-1c0-.4.62-.77.48-1.13s-.4-2.58.34-1.57a5.82,5.82,0,0,0,1.86,2c1.19.61,1.23.87,2.2-.12.2.59-.85,1.76.54,1.72a2.07,2.07,0,0,1-1.85.72,1.75,1.75,0,0,0-.95.53,6.55,6.55,0,0,0-.34,1.07c-.41.2-1.41-.67-1.74-1s-.76.14-1,.24-.64-.3-1.05-.16c-.12.81.71.5,1,.95s-.22.34-.4.28-.52.58-.69.52a5.31,5.31,0,0,1-.56-1.67c.14-.5.2-.5.64-.73.23-.12.21-.72.27-1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.49,164.8c-.35-.43-1.07-1-.91-1.54.28-1,.73-1.27,1.53-1.93s2.75,1,3.65,1.41c-.12-.71-.42-1.15.23-1.43.36-.16.92.24,1.27.36,1.29.48,2.58,1,3.85,1.47a3.61,3.61,0,0,1-1.15,1c-.57.34-.79.12-1.39-.14.16.28.34.56.5.85l-1.43.3c-.3.06-.63-.89-.91-.79-1,.39-1.93,1.25-2.6.2-.38.89-.34.93-1.23,1C410.39,165.56,409.93,165.1,409.49,164.8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.85,152.71c-.39,0-.75,0-1.11,0,.38-1.13,1-.9,2.06-1.05s1.39.51,1.75,1.34c.48-.27,2.22-1,2,.44.7-.12.86-.22,1.43.24.32.26.28.24.14.67s.38.62.57.82c1.31,1.5-1.34,1.56-1.62,1s-.34-.92-1-1-1.41,0-1.83-.49-2.52,1.41-2.75-.5c.69-.45,2.2.42,2.1-.69l-1-.18c.13-.08.21-.24.35-.32-.59-.59-.81.38-1.46.32A5.74,5.74,0,0,1,103.85,152.71Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301,172.56c0-.76.88-.5,1.17-1.07.38-.76-.35-.8.46-1.39.2-.16,1.47-.84,1.41-1.13-.14-.68-.4-1,0-1.53.61-.65,1.17-1.29,1.76-1.94a35.09,35.09,0,0,1,2.66-2.52c.81-.7,2.4-1,3.37-1.39a8.49,8.49,0,0,1,3.55-.63c1.47-.42,2.87-.62,4.08-1.63.56-.44,3.63-1.13,3.47.48-.13,1.34-3.09,1.86-3.84,2.1-1.49.53-3,1-4.48,1.41-1.25.39-2,1.28-3.1,2a7.62,7.62,0,0,0-2,1.29c-.46.61-.93,1.27-1.43,1.86-.85,1-2.26,2.26-2.24,3.75.06,1.9,1.17,2.7,2.52,3.63-.87.71-2.88.1-3.85,0a4.24,4.24,0,0,1-2.83-1.47C301.06,173.63,300.94,173.61,301,172.56Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228,206.49l-.14-.14a.7.7,0,0,0,.16-.1C228.07,206.37,228,206.43,228,206.49Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.2,355.73c.14.51.3,1,.44,1.52-.52.68-1.05,1.35-1.55,2s-.46.75-.08,1.54a.68.68,0,0,1-.59-.53c-1,.75-1.47.95-1.79,2.22a11.39,11.39,0,0,1-1.62,2.7c-.44.73-2,.21-2.4-.28s-2.42-.08-1.69-1.05S447.33,362,448,361c.22-.3,1-.47,1.29-.61a5.69,5.69,0,0,0,1.15-.9,8.49,8.49,0,0,0,1.15-1c.24-.41.2-1.07.46-1.44.39-.54.61-.2.77-.94s.38-.71,1-1a3,3,0,0,1,.4,1.43C454.55,356.28,454.88,356,455.2,355.73Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.38,307.8c-.49-.22-1-.44-1.48-.64A6.21,6.21,0,0,1,377,307c-.14,0-.2.22-.39.2s-.52-.08-.8-.1a4.89,4.89,0,0,1-1-.35,6.48,6.48,0,0,0-1.19-.42c-.38,0-.83.26-1.21.18-.75-.14-1.47-.6-2.26-.75a2.57,2.57,0,0,1,.08-.38c-.67-.16-1.71-.22-.93-1.13.26-.32.28-.48.67-.4s.74.38.89-.08c.28.18,1.57.48,1.63.62.52.89,1.21.69,2.16.79.24,0,.56.2.66-.1.14-.49.35-.73.71-.26a2.2,2.2,0,0,0,1.88.28c-.19.83.68,1.31,1.31,1.17C380.54,306,379.79,307.06,380.38,307.8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.82,175.53c.28.77,1.19.16,1.45-.45s3,1,3.51,1.28c-.22.74-1.23.76-1.83.94.48.08,1,0,.82.67.49-.24,1.19-.38,1.29-1.07.47.3,1.19.63,1.17,1.31a2.35,2.35,0,0,0-1.85.49,2.47,2.47,0,0,0,1.29.34c.83-.16.77-.18,1.07.68-.53-.1-1.07-.2-1.62-.32.06.37.13.73.19,1.09l-1.15.12c1.35.63,2.7,1.15,4.09,1.68a2.75,2.75,0,0,1,1.39,1c.59.64,1,.62,1.82.74-.18.28-.36.57-.55.83a6.63,6.63,0,0,1,2.08,0c.85.38.53.93.43,1.83-.43-.08-1.09-.36-1.38,0,.35.15.67.31,1,.47-1,.5-1.37,1-2.3.36a5.11,5.11,0,0,1,0,2.2,6,6,0,0,1-2.46-2c.51-.22,1.25-.3,1-1.07-.32.11-1,.53-1.31.47s-.85-.91-1.23-1.13-.81-.3-1.09.12c-.42.65.32.58.36,1.29-.36-.06-.7-.1-1.07-.14.12.36.22.71.35,1.07.52-.2.66-.47.86.14s.33,1,.49,1.55c.16-.8.56-.44,1.05-.22s.52.42.66,1.15.65.4.93.85a6.37,6.37,0,0,1,.2,1.67l-.62-.84c-.39.68.58.86.28,1.55-.14-.06-.32-.06-.47-.14.11.26.21.52.31.78-.26.11-1-.84-1.41-1.11-.77-.48-1.56-1-2.32-1.45.1.2.1.47.2.65l-1.35-.61c.26.45.5.91.76,1.35s.89.27,1.19.47c.47.32.93.66,1.41,1s.29.54.21,1.17c-1.27-.35-2.55-.67-3.82-1-.46-.12-.42-.69-.7-.77-.65-.18-1.29-.34-1.94-.5.08-.1.14-.22.22-.33a2.71,2.71,0,0,1-1.61-.6c.32-.18.66-.34,1-.52-.59-.33-1.25-.27-1.62-.81-.66-1-.64-1.64-1.65-1,0-.44-.24-.67-.65-.61,0,.19-.1.41-.08.61-.58-.14-1.21-.5-1.67-.06s-1.27.3-1.92.34c-.42,0-1.09-.78-.86-1.19s1.12-.68,1-1.33a8.12,8.12,0,0,0,2.93.22c.24-.08,1.65-.28,1.73-.5.19-.49-.8-1-1.05-1.17.79-.79,1.56-1.58,2.35-2.36.22-.22.56-.37.4-.67-.32-.6-.67-1.21-1-1.81-.5-.93-1.55-.69-2-1.52-.38-.64-.32-.58-1-.32l-1.45.55c0-1.21.22-1.05,1.27-1.36-.56-.46-1.81-2.09-2.5-1.35-.06-.32-.12-.64-.2-1s-.57,0-.77-.06c-.58-.28-.5-1.47-1.31-.7.65.18.73.5,1,1.13-1.53.36-2.46,0-4-.43l1.15,1.07c-.51.18-.65-.46-1.11-.52-.16,0-.29.48-.49.4l-.93-.36a10.65,10.65,0,0,0-3.1-.16,3.16,3.16,0,0,1-1.41-.39c-.57-.52.18-.8-.85-.7-.47,0-.73.48-1.29.16A4.27,4.27,0,0,1,123,175l3,.27c-1-1.05-1.88-.91-3.25-1.05a7.57,7.57,0,0,1-.32-1.7c-.08-.48.52-1.47.68-1.91a3.75,3.75,0,0,1,2.16-2.32,5.7,5.7,0,0,1,3.57-.45c-.08.39-.18.75-.28,1.11a13.43,13.43,0,0,0,2.9-1,4.28,4.28,0,0,1,1.42.06c.52,0,.4.75.7,1.13s.53.39.81.95c.38.79.28.81-.14,1.6s.2.64.58.26c.69-.69.63-.65,1.44-.16.22.14.88-.71,1.08-.89s1.15-.22,1.54-.26a4.1,4.1,0,0,1,2.62,1c.46.46,1.63,2.3,2.12,2.13.81-.3,2.28-.46,2.62.69C146,174.66,144.7,175.21,144.82,175.53Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.58,161.89c-.45-.54-.43-.89-.14-1.09a.87.87,0,0,1,.36-.18l.22-.06a.86.86,0,0,1,.24,0l.24,0c.61-.08,1.52-1.21,2-1.61a3.16,3.16,0,0,1,1.92-1.09c.32,0,.83-.23,1.13-.12s.82.44,1.23.08c-.22-.08-.26-.21-.41-.29l.35-.1a.83.83,0,0,1,.3,0v0c.48,0,.83.24,1.45.59-.56.2-1.77.8-.42,1.07a1.51,1.51,0,0,0-.51.06,1.19,1.19,0,0,0-.16.08.6.6,0,0,1,.33.32.72.72,0,0,1-.31.75,2.68,2.68,0,0,1-1,.68c-.82.22-1.77-.72-.8-1.35-.18-.16-.75-.22-.75.14,0,.73-.38.37-.81.63.33.1.53.44.25.74-.49.57-.71-.44-1-.32-.47.22.28.79,0,1.09s-.77.32-1.09.44c.1-.66-.38-1.12-.77-.78a.39.39,0,0,0-.06.23c0,.12,0,.25-.08.31s-.16.08-.34.06Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.82,154.93a15.39,15.39,0,0,1,1.81-2.64,2,2,0,0,1,2.48-.46c-.2.18-.42.36-.62.56.32,0,1.27-.28,1.47,0,.51.59.63.87,1.35.95.33,0,.93.91.65,1.13a2.37,2.37,0,0,1-1.23.6l-2.2.41c-.38.06-.83-.47-1.11-.39-.83.31-2.56,1.5-3.25.57C361.37,155.4,361.6,155.17,361.82,154.93Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.72,208.17a3.13,3.13,0,0,1-.31.56C228.19,208.31,228.46,208.09,228.72,208.17Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403,248.27c-.36-1.23,0-1,.47-2,.32.24,2.38-1.09,2.29.44,0,.22-.5.66-.62.85s-.44-.39-.61-.31C403.94,247.53,403.82,248.8,403,248.27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.21,191.28c.1-.24-.16-.66-.12-.92s.12-.77.22-1.13c.24-.91.22-1.62,1-2s1.07.93.14,1.09a1.41,1.41,0,0,0,.26.52c.46-.62.61-.44,1,0,.28.31.83.18,1.17.43s2.76,1.45,1.88,2.36a2,2,0,0,1,2,.52l-1.09.71c-.72-.22-2.74-.45-2.58-1.64-.72.29-.64.87-1.39,1.15-.44.17-.85.87-1.33,1.23s-.45-1.31-.63-1.43-1.63.32-1.87.34C126.16,192.23,127.09,191.55,127.21,191.28Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.19,149.59c.21.08.43.1.63.16a2.38,2.38,0,0,1-.36-.35c.18-.06.34-.24.52-.28-.48-.34-1.07.26-1.63,0a2,2,0,0,1,.28-.16,6.58,6.58,0,0,1-1.51-.28c.34-.14.68-.26,1-.38-.68-.71,1.52-.79,2-.89-.36-.33-1.09-.24-1.55-.41.58-1.51,2.5-.14,3-1.08-.52-.31-1.17-.11-1.75-.31.48-.7,1.51-.34,2.16-.16,1.07.26,1.49,1,2.26,1.86a1.67,1.67,0,0,0,1.79.64c.65-.18.26.57.41.81a1.18,1.18,0,0,0,1.13.54c-.19-.3-.35-.58-.51-.88.77-.67,2,.26,1.11,1,1.39.16,1.09.66.52,1.77.51-.2,1.72-.87,1.8.22,0-.2.24-.36.3-.58a4.11,4.11,0,0,1,1.05,1.15c-.64.2-2.22,1-2.6.7.28.65-.34.87-.75,1.21a2,2,0,0,1-.26-1.29c-1.49.43,1,2.56-1.29,1.37.4.59.22.89,0,1.5l-1.59-1.56.78,1.62c-.56-.47-.86-.77-1.59-.75a.81.81,0,0,1,.56.59c-1.09,0-2.68.16-3.39-1l1.62-.18c-.79-.19-2.1.06-2.56-.65l.84-.06a4.74,4.74,0,0,1-1.53-.58c1.61-.67,3.17-.53,4.84-.85a6.05,6.05,0,0,1-2.68-.12c.58-.08,1.19-.14,1.77-.23-.5-.46-1.69-.08-2.42-.38.12.73-.3.18-.42.24-.38.19-.52.57-1,.33,0-.1,0-.23.06-.33-.4-.16-.6.1-.93.35s-.42-.39-.78-.33-.53-.46-.12-.52,1,0,1.33-.55c-1,.39-2.58.39-2.77-1.08Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.22,283c-.06-.36-.13-.73-.19-1.09a1,1,0,0,1,.75.77c.34-.14.44.32.38.64-.08.1-.18.18-.26.28.1,0,.16.13.34.13a1.19,1.19,0,0,1,0,.46c.57,0,.09,1.49,0,1.9a.87.87,0,0,1-.2-.15c0,.31,0,.59,0,.89-.32-.5-.1-1-.44-1.49-.73.52-.34.93-.2,1.55.16.83-.81,1.19-.51.25h-.12c-.2.7-1.31-.13-1.47-.57-.26-.69.64-2-.73-1.82a5.65,5.65,0,0,0,0,.59c-.3-.2-.3-.08-.34-.48-.18.22-.22.12-.34.44-.25-1.33-.77.5-1.05.73-.63-.87.44-1.56,1.05-1.74.32-.1.1-.93.7-.89s.59.67.29,1c.52-.2.78-1.15,1.33-.72,0-.51.1-.81.5-.55C393.87,282.87,393.79,282.93,394.22,283Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.59,331.26a30.8,30.8,0,0,1,.79,5.37c-.06,1.79-.95,3.89-1.37,5.65-.39,1.45-2,2.54-2.26,4-.33,1.72-.15,4.44-2.14,4.5a2.34,2.34,0,0,0-2.2,1c-.4.38-1.45.77-1.86.28-.82-1-.74-1.39-1.73-.54s-1,.62-2.14.44c-1.74-.28-3.19-.83-3.61-2.86-.14-.59-.61-2-1.27-2s-.53-1.78-.61-2.5c-.54,1.15-.5,1.81-1.69,1.55.72-1.19,1.65-2.32,1.19-3.73a19.79,19.79,0,0,1-2.6,3.49,21.05,21.05,0,0,1-1.34-2.12c-.64-1.15-.7-1.37-1.85-1.79a21.71,21.71,0,0,0-5.35-1.13c-.54-.06-1.47.8-1.95,1.09s-1.54-.17-2.22.16-1.82.56-2.12,1.23c-.1.2-.38,1.05-.57,1.05-.6,0-1.21,0-1.81.06-.79,0-1.59.14-2.38.22-1.11.12-1.35.42-2.2,1.27-.61.58-1.53.32-2.3.32s-1.45-.86-2.08-1.33.79-1.43.87-1.65c.24-.63-.34-2.44-.44-3.15a18.16,18.16,0,0,0-1.58-5.14c-.32-.69-.78-1.21-.54-2a2.36,2.36,0,0,0,0-2.22c-.67-1.67-.24-3.09.42-4.74.18.4.34.83.51,1.25a3.82,3.82,0,0,1,1.69-2.26,5.85,5.85,0,0,1,2.24-1.21l4.07-.93c1-.26,1-1.13,1.44-2.2.78-2.07,2.92-3.24,4.52-4.6.28-.24,1.49-1.61,1.83-1.41,1,.51,2,1,2.95,1.56a8.66,8.66,0,0,1,1.19-3.27c.72-1.07,1.75-.47,2.88-.28,0-.49-.08-1-.1-1.44a22.64,22.64,0,0,1,3.07.22,3.07,3.07,0,0,1,2.52,1.15,5,5,0,0,0-1.35,2.16c-.29,1.19-.71,1.54.28,2.1s2.08,1.25,3.13,1.88c.58.36,1.07,1.33,1.63,1.53,1.57.59,2.22-3.07,2.18-4.22a10.48,10.48,0,0,1,0-3c.24-.85.32-2.56,1.27-2.81a22.36,22.36,0,0,1,1.63,5.37,1.12,1.12,0,0,1,1.72.85c.08,1.39,0,1.79.87,2.8.62.71.36,1.78.36,2.73,0,.36,2.28,1.39,2.62,1.57.83.48.81,1.05,1.11,2,.16.54.34,1.09.5,1.65s.73-.36.87-.3c1.15.38.14,1.29.89,1.95Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.93,245.69a2.72,2.72,0,0,0,2.3-1.41c.53-.75,2.1-.55,2.93-.65.44,0,.14.57.87.24.5-.22.08-.56.36-.94s.85-.83.87-1.23c0-.77.26-.69.92-.95-.14.14-.68,1-.22,1a3.77,3.77,0,0,0,1.35-.51,3.48,3.48,0,0,0,1.56-2c.2-.62.4-1.23.58-1.85.08-.22-.48-.45-.34-.91s1.05-2.54,1.45-1c-.18-.7.2-1.23.87-.87-.08.41-.28.79-.1,1.15s.64,1,.62,1.36c0,.58.14,1.17-.32,1.47s-.28.66-.28,1.21c-.77-.38-.67.5-.65,1,0,.84-.26.87-.4,1.55-.08.36.1,1.61,0,1.65-.54.29-.65.81-1.27,1,.06-.28.12-.58.2-.88a6.55,6.55,0,0,0-1,1.33c-.12-.26-.26-.53-.4-.79-.57.81-1.78,1.25-2.38.28-.53.37-.39.79.06,1.17-.75-.14-1.09.81-1.47,1.33-.69-.62-1.28-1.17-.33-2-.62-.06-1.55-.39-2,.14-.08.12-.79.26-1,.38-.41.26-.65.49-1-.08-.32,1.17-1,.26-1.68.85.39.56.65,0,.93.5.1.16.55.77.43,1a6,6,0,0,1-1.54,2.6c-1,.73-.93-1.17-.56-1.75.18-.28.56-1.17-.14-1.27s0,.85-.77.76c0-.34-.08-.66-.12-1C399.9,247.16,401.32,246.72,400.93,245.69Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.34,222.37a15.81,15.81,0,0,1-5.29-4.12c1-.3,1.27.15,2.2.45,1.19.4,1.39.12,2,1.33.22.4.28.67.66.79s.77.18.93.44C80.53,222.39,80.67,222.85,79.34,222.37Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.8,192.11l-1.09.16c-.36,0-.3.3-.61.47a2.42,2.42,0,0,1-1.79.12,4.88,4.88,0,0,1-1.07-.24c-.16-.13-.34-.69-.57-.65l-2.34.3c-.3-.82.89-.6,1.15-1.31a1.75,1.75,0,0,1-.32,0l.06-.3c-.4.06-.56-.2-.28-.53-.55,0-2.16.37-2.3-.38.89,0,1.88-.38,2.86-.36,0-.08,0-.18,0-.27a1.07,1.07,0,0,1-1-.08c.34-.18.68-.34,1-.5-.42-.1-1.23-.48-1.63-.34-.83.34-1,.5-1.88.16.31-.16.23-.26.59-.22a2.55,2.55,0,0,1,0-.39c.22.14.63.35.79.08s-.73-.28-.27-.84,1.66.88,1.54-.37c-.43-.06-.77,0-.89-.44,1,0,.91.14,1.63.77.14.12.71.24.73.5a.43.43,0,0,1-.54.44,13.48,13.48,0,0,0,.74,1.21,7.14,7.14,0,0,1,.51-1.17c.26-.44.8.07.38-.94.54-.1.85.52,1.21.88-.16-.46,0-1,.54-1s.75.46,1.11,1c-.06-.36-.1-.72-.16-1.09,1,.45,1.23-.06,2.22,0-.58-1.52,2.74-.15,2.06,1,.56-.22.93.14,1.41.41.24.16-.12.8.34,1.13-.38.38-.68.95-1.25.62,0,.79-.4,1.33-1.11,1.13C216.15,191,215.22,191.85,214.8,192.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.84,254.66a10.24,10.24,0,0,1-3.07,1.29,10.65,10.65,0,1,1,3.07-1.29Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.48,244.4a3.24,3.24,0,1,1-3.23-3.24A3.23,3.23,0,0,1,376.48,244.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.84,253.33v1.33a10.24,10.24,0,0,1-3.07,1.29,10.58,10.58,0,0,1-8.11-1.29v-1.33a5.59,5.59,0,1,1,11.18,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.93,229.57c-.23-2.35-1.84-4.68-4.68-4.68s-4.45,2.33-4.68,4.68c-.36,3.61,2.08,6.89,4.68,9.87C375.85,236.46,378.29,233.18,377.93,229.57Zm-4.68,2.6a2.57,2.57,0,1,1,2.57-2.57A2.57,2.57,0,0,1,373.25,232.17Z",
    style: {
      fill: "#138DE8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450,195.81a10.65,10.65,0,0,1-11.18,0,10.63,10.63,0,1,1,11.18,0Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.59,185.54a3.24,3.24,0,1,1-3.23-3.23A3.23,3.23,0,0,1,447.59,185.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450,194.47v1.34a10.65,10.65,0,0,1-11.18,0v-1.33a5.59,5.59,0,1,1,11.18,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449,170.71c-.23-2.34-1.84-4.68-4.68-4.68s-4.45,2.34-4.68,4.68c-.36,3.61,2.08,6.89,4.68,9.88C447,177.6,449.4,174.32,449,170.71Zm-4.68,2.6a2.57,2.57,0,1,1,2.57-2.57A2.57,2.57,0,0,1,444.36,173.31Z",
    style: {
      fill: "#138DE8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312,209.16a10.64,10.64,0,1,1,4.74-11.57A10.6,10.6,0,0,1,312,209.16Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 306.44,
    cy: 198.9,
    r: 3.24,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312,207.82v1.34a10.68,10.68,0,0,1-11.19,0v-1.34a5.6,5.6,0,0,1,11.19,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.13,184.06c-.23-2.34-1.85-4.67-4.68-4.67s-4.45,2.33-4.69,4.67c-.35,3.62,2.09,6.89,4.69,9.88C309.05,191,311.49,187.68,311.13,184.06Zm-4.68,2.6A2.57,2.57,0,1,1,309,184.1,2.56,2.56,0,0,1,306.45,186.66Z",
    style: {
      fill: "#138DE8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.64,332.29a10.35,10.35,0,0,1-3.07,1.29,10.65,10.65,0,1,1,3.07-1.29Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.28,322a3.24,3.24,0,1,1-3.23-3.23A3.24,3.24,0,0,1,273.28,322Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.64,331v1.33a10.35,10.35,0,0,1-3.07,1.29,10.62,10.62,0,0,1-8.12-1.29V331a5.6,5.6,0,0,1,11.19,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.73,307.2c-.23-2.34-1.85-4.68-4.68-4.68s-4.45,2.34-4.69,4.68c-.35,3.61,2.09,6.89,4.69,9.88C272.65,314.09,275.09,310.81,274.73,307.2Zm-4.68,2.6a2.57,2.57,0,1,1,2.56-2.57A2.57,2.57,0,0,1,270.05,309.8Z",
    style: {
      fill: "#138DE8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.13,301.78a10.64,10.64,0,1,1,4.74-11.57A10.6,10.6,0,0,1,167.13,301.78Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.77,291.52a3.24,3.24,0,1,1-3.23-3.24A3.23,3.23,0,0,1,164.77,291.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.13,300.44v1.34a10.66,10.66,0,0,1-11.19,0v-1.33a5.6,5.6,0,0,1,11.19,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.22,276.68c-.23-2.34-1.85-4.67-4.68-4.67s-4.45,2.33-4.69,4.67c-.35,3.62,2.09,6.89,4.69,9.88C164.14,283.57,166.58,280.3,166.22,276.68Zm-4.68,2.6a2.57,2.57,0,1,1,2.56-2.56A2.57,2.57,0,0,1,161.54,279.28Z",
    style: {
      fill: "#138DE8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.26,257.75a10.72,10.72,0,0,1-3.07,1.28,10.65,10.65,0,0,1-12.86-7.8,10.64,10.64,0,1,1,15.93,6.52Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.9,247.49a3.24,3.24,0,1,1-3.24-3.24A3.24,3.24,0,0,1,109.9,247.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.26,256.41v1.34a10.72,10.72,0,0,1-3.07,1.28,10.52,10.52,0,0,1-8.12-1.29v-1.33a5.6,5.6,0,0,1,11.19,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.35,232.65c-.24-2.34-1.85-4.67-4.69-4.67s-4.44,2.33-4.68,4.67c-.36,3.62,2.08,6.89,4.68,9.88C109.27,239.54,111.71,236.27,111.35,232.65Zm-4.69,2.6a2.57,2.57,0,1,1,2.57-2.56A2.56,2.56,0,0,1,106.66,235.25Z",
    style: {
      fill: "#138DE8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.36,169.05a10.66,10.66,0,0,1-11.19,0,10.63,10.63,0,1,1,11.19,0Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,158.79a3.24,3.24,0,1,1-3.23-3.24A3.23,3.23,0,0,1,201,158.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.36,167.71v1.34a10.66,10.66,0,0,1-11.19,0v-1.33a5.6,5.6,0,0,1,11.19,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.45,144c-.23-2.34-1.85-4.67-4.68-4.67s-4.45,2.33-4.68,4.67c-.36,3.62,2.08,6.89,4.68,9.88C200.37,150.84,202.81,147.57,202.45,144Zm-4.68,2.6a2.57,2.57,0,1,1,2.57-2.56A2.57,2.57,0,0,1,197.77,146.55Z",
    style: {
      fill: "#138DE8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.37 290.7 141.73 289.25 141.81 289.27 141.37 290.7",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.6 286.27 143.59 283.33 143.92 283.46 142.82 286.35 142.6 286.27",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "144.67 280.42 145.86 277.55 146.38 277.79 145.12 280.61 144.67 280.42",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.14 274.72 148.5 271.93 149.15 272.27 147.72 275.01 147.14 274.72",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.96 269.18 151.51 266.49 152.24 266.94 150.66 269.58 149.96 269.18",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.17 263.85 154.92 261.27 155.66 261.8 153.91 264.34 153.17 263.85",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.76 258.76 158.69 256.32 159.43 256.94 157.5 259.33 156.76 258.76",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.72 253.96 162.86 251.69 163.57 252.38 161.46 254.62 160.72 253.96",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.11 249.52 167.45 247.46 168.05 248.18 165.76 250.23 165.11 249.52",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.89 245.51 172.41 243.69 172.92 244.41 170.44 246.24 169.89 245.51",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.03 241.99 177.74 240.44 178.13 241.15 175.49 242.72 175.03 241.99",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.54 239.05 183.4 237.81 183.65 238.41 180.85 239.71 180.54 239.05",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.32 236.74 189.29 235.82 189.43 236.29 186.51 237.27 186.32 236.74",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.32 235.08 195.37 234.51 195.41 234.74 192.4 235.43 192.32 235.08",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.51 234.09 200 233.96 198.52 234.18 198.51 234.09",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.91 213.21 260.67 211.93 260.75 211.97 259.91 213.21",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "262.28 209.48 263.99 207.11 264.27 207.33 262.47 209.62 262.28 209.48",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.78 204.8 267.65 202.56 268.08 202.93 266.15 205.11 265.78 204.8",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.61 200.37 271.62 198.25 272.14 198.76 270.08 200.82 269.61 200.37",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.71 196.19 275.86 194.2 276.43 194.84 274.26 196.78 273.71 196.19",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "278.08 192.29 280.36 190.44 280.92 191.16 278.64 192.97 278.08 192.29",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.7 188.67 285.1 186.97 285.63 187.77 283.25 189.43 282.7 188.67",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.54 185.35 290.05 183.82 290.55 184.68 288.07 186.19 287.54 185.35",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292.61 182.39 295.22 181.05 295.64 181.88 293.07 183.24 292.61 182.39",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.87 179.79 300.57 178.63 300.91 179.44 298.25 180.62 297.87 179.79",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.3 177.56 306.07 176.6 306.33 177.36 303.6 178.36 303.3 177.56",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.88 175.75 311.72 175 311.88 175.63 309.09 176.45 308.88 175.75",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.57 174.34 317.45 173.8 317.54 174.28 314.7 174.9 314.57 174.34",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.35 173.37 323.25 173.05 323.28 173.28 320.4 173.73 320.35 173.37",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.24 172.82 327.74 172.76 326.25 172.91 326.24 172.82",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "356.08 257.47 355.71 256.02 355.74 256.01 356.08 257.47",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.88 253.18 353.94 250.38 354.05 250.34 354.95 253.16 354.88 253.18",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.91 247.6 351.8 244.86 352 244.78 353.07 247.54 352.91 247.6",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.62 242.15 349.37 239.47 349.65 239.33 350.87 242.04 350.62 242.15",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.05 236.82 346.67 234.21 347.04 234.01 348.38 236.66 348.05 236.82",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.23 231.63 343.72 229.08 344.16 228.82 345.63 231.4 345.23 231.63",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "342.17 226.57 340.55 224.1 341.02 223.79 342.62 226.29 342.17 226.57",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.88 221.66 337.15 219.26 337.65 218.9 339.36 221.32 338.88 221.66",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.37 216.91 333.54 214.59 334.06 214.17 335.88 216.52 335.37 216.91",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.65 212.32 329.71 210.09 330.25 209.62 332.18 211.87 331.65 212.32",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.72 207.91 325.68 205.77 326.24 205.23 328.27 207.4 327.72 207.91",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.6 203.69 321.46 201.65 322.04 201.04 324.16 203.11 323.6 203.69",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "319.29 199.65 317.07 197.7 317.64 197.05 319.86 199.02 319.29 199.65",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.82 195.8 312.52 193.94 313.06 193.26 315.37 195.13 314.82 195.8",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "310.18 192.14 307.8 190.39 308.32 189.67 310.71 191.44 310.18 192.14",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.38 188.69 302.93 187.05 303.43 186.28 305.89 187.95 305.38 188.69",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "300.44 185.45 297.93 183.91 298.41 183.11 300.94 184.67 300.44 185.45",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.38 182.42 292.81 180.98 293.26 180.15 295.85 181.6 295.38 182.42",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.2 179.59 287.57 178.26 288 177.39 290.64 178.74 290.2 179.59",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "284.91 176.97 282.23 175.74 282.63 174.84 285.33 176.09 284.91 176.97",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "279.52 174.55 276.8 173.41 277.17 172.49 279.91 173.64 279.52 174.55",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.05 172.32 271.29 171.27 271.63 170.35 274.41 171.4 274.05 172.32",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.51 170.28 265.71 169.33 266.01 168.41 268.82 169.36 268.51 170.28",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "262.9 168.43 260.07 167.57 260.34 166.66 263.18 167.52 262.9 168.43",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.23 166.76 254.38 165.99 254.61 165.1 257.48 165.86 257.23 166.76",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.51 165.27 248.64 164.59 248.84 163.71 251.73 164.38 251.51 165.27",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.75 163.96 242.85 163.36 243.02 162.49 245.93 163.08 245.75 163.96",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.95 162.81 237.04 162.3 237.18 161.44 240.1 161.94 239.95 162.81",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "234.12 161.82 231.19 161.39 231.31 160.54 234.25 160.97 234.12 161.82",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.26 160.99 225.32 160.62 225.42 159.81 228.37 160.16 228.26 160.99",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.39 160.28 219.45 159.99 219.51 159.24 222.47 159.51 222.39 160.28",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.5 159.73 213.55 159.5 213.6 158.8 216.56 159 216.5 159.73",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.6 159.3 207.64 159.14 207.67 158.5 210.64 158.63 210.6 159.3",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.69 159.01 201.73 158.91 201.74 158.32 204.71 158.39 204.69 159.01",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.77 158.84 195.81 158.8 195.81 158.27 198.78 158.28 198.77 158.84",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.85 158.79 189.88 158.81 189.88 158.34 192.84 158.29 192.85 158.79",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.92 158.84 183.96 158.91 183.95 158.54 186.91 158.43 186.92 158.84",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "181.01 159 178.05 159.12 178.03 158.85 180.99 158.68 181.01 159",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.09 159.26 172.13 159.43 172.12 159.25 175.07 159.04 175.09 159.26",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.17 159.62 166.22 159.84 166.21 159.76 169.16 159.5 169.17 159.62",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.04 160.1 161.54 160.23 163.03 160.07 163.04 160.1",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.24 271.19 287.27 270.11 287.33 270.18 286.24 271.19",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "289.38 268.12 291.6 266.25 291.83 266.55 289.54 268.31 289.38 268.12",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.9 264.47 296.28 262.81 296.61 263.31 294.19 264.89 293.9 264.47",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "298.74 261.25 301.25 259.79 301.62 260.46 299.08 261.84 298.74 261.25",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.83 258.43 306.48 257.21 306.82 258.01 304.2 259.19 303.83 258.43",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.17 256.1 311.92 255.12 312.21 256 309.49 256.95 309.17 256.1",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.7 254.25 317.53 253.51 317.75 254.47 314.96 255.17 314.7 254.25",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.39 252.92 323.27 252.48 323.4 253.44 320.56 253.9 320.39 252.92",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.18 252.18 329.09 252.02 329.12 252.92 326.26 253.11 326.18 252.18",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "332.01 252 334.92 252.12 334.87 252.96 332 252.87 332.01 252",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.82 252.4 340.71 252.81 340.6 253.49 337.74 253.16 337.82 252.4",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "343.57 253.36 346.39 254.04 346.27 254.54 343.45 253.95 343.57 253.36",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.18 254.85 351.93 255.79 351.85 256.03 349.07 255.23 349.18 254.85",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.7 256.87 356.08 257.47 354.66 256.96 354.7 256.87",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.54 160.23 163.03 160.09 163.03 160.16 161.54 160.23",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.04 159.97 169.05 160.01 169.04 160.31 166.04 160.17 166.04 159.97",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.07 160.18 175.07 160.47 175 160.97 172.03 160.59 172.07 160.18",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.06 160.89 181.04 161.42 180.91 162.05 177.97 161.46 178.06 160.89",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.99 162.06 186.92 162.81 186.71 163.54 183.82 162.74 183.99 162.06",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.82 163.66 192.69 164.63 192.39 165.44 189.56 164.45 189.82 163.66",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "195.51 165.7 198.3 166.88 197.94 167.7 195.18 166.52 195.51 165.7",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.05 168.15 203.75 169.53 203.3 170.36 200.64 168.98 201.05 168.15",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.4 170.99 208.99 172.54 208.47 173.38 205.91 171.82 206.4 170.99",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.53 174.2 214 175.95 213.43 176.73 210.97 175.02 211.53 174.2",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.41 177.78 218.76 179.69 218.16 180.41 215.82 178.53 216.41 177.78",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.04 181.68 223.25 183.74 222.64 184.38 220.44 182.36 221.04 181.68",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.4 185.87 227.48 188.06 226.86 188.63 224.78 186.47 225.4 185.87",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "229.47 190.34 231.4 192.66 230.86 193.11 228.89 190.84 229.47 190.34",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.26 195.04 235.05 197.48 234.59 197.81 232.75 195.44 233.26 195.04",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.78 199.96 238.42 202.48 238.07 202.71 236.36 200.25 236.78 199.96",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.99 205.06 241.5 207.67 241.33 207.77 239.73 205.22 239.99 205.06",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "242.98 210.4 243.67 211.73 242.92 210.43 242.98 210.4",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-5--inject-86"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 349.2,
    y: 258.02,
    width: 85.64,
    height: 85.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.33,344.16H348.7V257.52h86.63Zm-85.63-1h84.63V258.52H349.7Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.6,263.11a2.52,2.52,0,1,1-2.52-2.53A2.52,2.52,0,0,1,358.6,263.11Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.89,263.11a2.52,2.52,0,1,1-2.52-2.53A2.52,2.52,0,0,1,368.89,263.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.18,263.11a2.52,2.52,0,1,1-2.52-2.53A2.52,2.52,0,0,1,379.18,263.11Z",
    style: {
      fill: "#138DE8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.2,
    y: 267.54,
    width: 85.64,
    height: 1,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.21,313.79c-3.75,5.35-24.61,22.86-43.19,23.89-6.31.34-25.75-25.33-29.72-35.34-2.85-7.18,12.5-12,17-11.25,5.6.93,16.16,23.15,20.1,23.26,6.33.16,18.13-4.35,31.24-7.12C407.36,305.8,408.11,309.67,405.21,313.79Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.24,315.69c-4.61,6.93-20,18.3-20,18.3L383,329.24l-7.22-15.69S390,309,399.36,306.91a20.64,20.64,0,0,1,3.35-.5C408.68,306,409.22,309.74,405.24,315.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.64,310.9a7.82,7.82,0,0,1,0,4,7.54,7.54,0,0,1,0-4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.72,319a7.82,7.82,0,0,1-4,0,6.55,6.55,0,0,1,2-.26A6.87,6.87,0,0,1,385.72,319Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406,307.8a7.86,7.86,0,0,1-4,0,6.94,6.94,0,0,1,2-.26A7.28,7.28,0,0,1,406,307.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.93,315.93a7.78,7.78,0,0,1,2.83,2.83,7.78,7.78,0,0,1-2.83-2.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.23,325.48a7.24,7.24,0,0,1,1.6,1.23,6.68,6.68,0,0,1,1.23,1.6,7.18,7.18,0,0,1-1.59-1.23A7,7,0,0,1,387.23,325.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.24,315.69c-4.61,6.93-20,18.3-20,18.3L383,329.24c5.73-6.74,14.58-17,19.67-22.83C408.68,306,409.22,309.74,405.24,315.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388,330.79c-1.2-2.89-6.53-14.52-7.86-17-.09-.17-.22-.16-.14,0a169.76,169.76,0,0,0,7.89,17C387.91,330.9,388,330.86,388,330.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.81,303.45c-1.17-2.13-5.67-12.4-6.28-15.54s-1.72-12.29.64-13,2.89,2,2.89,2,.15-3.94,2.58-4.45,3.14,3.66,3.14,3.66.45-4,2.91-4.36,2.47,4,2.47,4,.24-3.71,2.38-3.12c2.58.7,1.38,7.49,2.31,10.91.21.77,5.42,15.4,5.42,15.4Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.15,275.3c-.87,5-.39,7.33,1.51,11.95,0,.09-.09.17-.14.08-2.27-4.36-3.29-7.2-1.61-12.08C341,275,341.2,275.07,341.15,275.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.86,275.67c-.46,5.26,0,7.8,1.67,12.78,0,.07-.09.12-.12.05-2-4.75-3-7.61-1.82-12.82C335.64,275.45,335.88,275.42,335.86,275.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.15,277.1c-.07,5.13.36,7.93,2.56,12.57a.09.09,0,0,1-.16.09A17,17,0,0,1,330,277.11C330.05,276.79,330.16,276.77,330.15,277.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.8,300.94a62.85,62.85,0,0,0-.25-9.17c-.5-2.81-6.24-12.6-8.42-11.49-2.82,1.45-.63,7.75.85,10.7,0,0-6.53,3.34-5.93,8.2S354.8,300.94,354.8,300.94Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.48,280.93c-1.62,3.18.57,6.92,1.79,9.89a.3.3,0,0,1-.24.42c-2.65,1.58-5.92,4.58-6.14,7.82,0,.09-.15.1-.15,0-.23-3.51,2.74-6.72,5.75-8.26-1.3-3-3.33-6.88-1-9.88C345.47,280.9,345.49,280.91,345.48,280.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.19,322.73a41.35,41.35,0,0,0-.82,4.33.88.88,0,0,1,0-.16c-.06-.82-.11-1.65-.24-2.45a0,0,0,0,0-.08,0,12.84,12.84,0,0,0,.06,2.48c0,.39.08.78.14,1.16-.08.66-.15,1.32-.2,2-.09,1.23-.42,6.52-.41,7.43,0,.2.23.22.27,0,.2-.94.76-6.38.91-7.61a65.88,65.88,0,0,0,.48-7.16C391.28,322.67,391.2,322.68,391.19,322.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.4,343.12v-4.54c-5.17-11.38-13.26-25.39-24.46-34.06-2.64-2-8.24-1.17-11.79.9-1.27.73-5.54,7.63-6.48,13.95-.47,3.21-1.63,13.85-2.41,23.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.5,321.82a7.18,7.18,0,0,1,0,2,6.77,6.77,0,0,1-.54,1.94,6.76,6.76,0,0,1,0-2A6.84,6.84,0,0,1,402.5,321.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.15,333.61a7.18,7.18,0,0,1,0,2,7.66,7.66,0,0,1-.54,1.95,7.18,7.18,0,0,1,0-2A6.84,6.84,0,0,1,423.15,333.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.28,328.14a7.12,7.12,0,0,1-2,0,7.55,7.55,0,0,1-1.95-.54,7.18,7.18,0,0,1,2,0A7.48,7.48,0,0,1,414.28,328.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.73,307.54a7.18,7.18,0,0,1-2,0,7.48,7.48,0,0,1-1.94-.54,7.12,7.12,0,0,1,2,0A7.55,7.55,0,0,1,406.73,307.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.26,311.09a7.17,7.17,0,0,1,1.41,1.45,6.83,6.83,0,0,1,1,1.75,7.12,7.12,0,0,1-1.41-1.44A7.2,7.2,0,0,1,413.26,311.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.75,336.12a7.12,7.12,0,0,1,1.41,1.44,6.89,6.89,0,0,1,1,1.76,7.71,7.71,0,0,1-2.4-3.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.41,333.78a8,8,0,0,1,2.41,3.21,8,8,0,0,1-2.41-3.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.65,314a7.12,7.12,0,0,1,1.41,1.44,7.2,7.2,0,0,1,1,1.76,7.17,7.17,0,0,1-1.41-1.45A7,7,0,0,1,394.65,314Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.81,329a7.12,7.12,0,0,1,1.44-1.41,6.89,6.89,0,0,1,1.76-1,7.17,7.17,0,0,1-1.45,1.41A7.33,7.33,0,0,1,390.81,329Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.81,324a7.17,7.17,0,0,1,1.45-1.41,6.83,6.83,0,0,1,1.75-1,7.12,7.12,0,0,1-1.44,1.41A7.2,7.2,0,0,1,419.81,324Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.16,340a7.17,7.17,0,0,1,1.45-1.41,7,7,0,0,1,1.75-1,7.12,7.12,0,0,1-1.44,1.41A7.2,7.2,0,0,1,411.16,340Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.59,315.93c3.25-.15,7.15-6.29,8.14-10.65.07-.3-1.11-2.91-2.38-6.15-.77-2-1.58-4.19-2.17-6.26-.12-.42-1.34.77-1.34.77l-2.5,1.41-8.25,4.68a34,34,0,0,1,3.52,7.6,5.73,5.73,0,0,1,.16.87.44.44,0,0,0,0,.15C396,310,397.45,316.07,400.59,315.93Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.77,308.2a.44.44,0,0,0,0,.15,8.61,8.61,0,0,0,1.35-.31c8.7-2.69,6.62-14.12,6.62-14.12l-3.42,1.13-8.25,4.68a34,34,0,0,1,3.52,7.6A5.73,5.73,0,0,1,395.77,308.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.45,278.24c2.6,4.28,3.56,18.32,1,22.15-3.69,5.55-11.42,8-16.56,3.14-5-4.67-5.92-23-2.92-26.63C387.4,271.51,397.61,271.92,401.45,278.24Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.77,300.17h0",
    style: {
      fill: "none",
      stroke: "#f6a89f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.89,290.21s.08,0,.08.08c0,.94.24,2,1.12,2.27,0,0,0,.06,0,.06C391,292.55,390.77,291.11,390.89,290.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.66,289.16c1.51-.23,1.85,2.81.45,3S390.39,289.35,391.66,289.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.1,290.73s-.07.06-.06.09c.13.94.13,2-.69,2.45,0,0,0,.06,0,.05C385.39,293.06,385.38,291.6,385.1,290.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.15,289.84c-1.53.06-1.31,3.11.11,3.06S385.43,289.8,384.15,289.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.7,287.64c-.42-.06-.81-.19-1.22-.29a2,2,0,0,1-1.19-.52.65.65,0,0,1,0-.79,1.61,1.61,0,0,1,1.59-.35,2.39,2.39,0,0,1,1.46.86A.7.7,0,0,1,392.7,287.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.8,288.45c.41-.12.78-.3,1.17-.45a2.05,2.05,0,0,0,1.11-.69.65.65,0,0,0-.12-.78,1.62,1.62,0,0,0-1.62-.12,2.34,2.34,0,0,0-1.33,1.06A.69.69,0,0,0,382.8,288.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.64,298.55c-.2.25-.39.57-.73.64a2.44,2.44,0,0,1-1-.12s-.06,0,0,.05a1.27,1.27,0,0,0,1.25.38,1,1,0,0,0,.64-.92C392.74,298.53,392.67,298.51,392.64,298.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.33,295.84a3.22,3.22,0,0,1-2,1.67,3.94,3.94,0,0,1-1.14.18h-.44a.22.22,0,0,1-.21-.19h0a.33.33,0,0,1,0-.1h0v-.08c-.1-.72-.16-1.83-.16-1.83-.25.16-1.53.92-1.55.54a48.33,48.33,0,0,1,.15-9.84.09.09,0,0,1,.18,0c.28,3,0,6.08.25,9.13a5.65,5.65,0,0,1,1.46-.63c.11,0,.07,2.15.14,2.47v0a4.45,4.45,0,0,0,3.2-1.4C391.3,295.71,391.38,295.76,391.33,295.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.59,297.28a3.88,3.88,0,0,0,1.66,1,1.69,1.69,0,0,0,1-.06c.73-.28.68-1,.47-1.55a4.24,4.24,0,0,0-.44-.86A5,5,0,0,1,388.59,297.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.25,298.29a1.69,1.69,0,0,0,1-.06c.73-.28.68-1,.47-1.55A1.78,1.78,0,0,0,390.25,298.29Z",
    style: {
      fill: "#ff99ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.75,289.84c-2.39.31-3.25-5.51-3.25-5.51s-3.73,0-6.42-4.58c0,0-4.09,3.78-8.11,3.8-6.31,0-7.63-7.91-5.65-9.95,2.8-2.89,9.18-.65,9.18-.65s8.26-4.06,12,1.34a4.55,4.55,0,0,1,5,3.68C406.54,282.22,404.53,289.62,402.75,289.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.47,284.85a8.24,8.24,0,0,1-5-1.63,6.14,6.14,0,0,1-2.39-5.08c0-.1-.16-.11-.16,0a7,7,0,0,0,2.05,5.6,5.7,5.7,0,0,0,5.54,1.29C400.58,285,400.58,284.85,400.47,284.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.3,275.4c-1.49-1.3-3.37-1.19-5.17-.79-.1,0-.06.19,0,.16a5.14,5.14,0,0,1,5,1.6c1.18,1.26,1.31,3.1,1.24,4.75a12.87,12.87,0,0,1-3.63,8.49s0,.1.05.06a12.83,12.83,0,0,0,4.12-9.32C406.92,278.63,406.67,276.6,405.3,275.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.8,273.19a6.06,6.06,0,0,0-3.83-1.93,7.24,7.24,0,0,0-5,1.46,4.08,4.08,0,0,0-1.47,3.83,7.21,7.21,0,0,0,2.44,4.19s.08,0,0-.05a7.23,7.23,0,0,1-2-3.85,3.76,3.76,0,0,1,1.56-3.68c2.29-1.58,6-2.09,8.1.15C388.75,273.38,388.87,273.27,388.8,273.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.37,289.9s2-5.07,4.26-4.44,1.41,7.48-.71,8.88a2.42,2.42,0,0,1-3.46-.53Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.34,287.42s.06,0,0,.06a6.09,6.09,0,0,0-2.21,4.45,1.33,1.33,0,0,1,1.86-.81c.05,0,0,.09,0,.1a1.5,1.5,0,0,0-1.48.87,7,7,0,0,0-.46,1.48c-.05.16-.33.14-.31,0v0C402.23,291.43,403.17,288.14,405.34,287.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.26,343.12c-1.77-12.28-5.55-26.31-9.22-30.94-3.07-3.88-8.16-2.51-8.06,11.7,0,5.26-.47,12.76-1.09,19.24Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.07,317.33c1.56-13.36,7.58-12,11.92-.79a191.13,191.13,0,0,1,7,24l-21.75,1S406.08,325.88,407.07,317.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.15,333.61a7.18,7.18,0,0,1,0,2,7.66,7.66,0,0,1-.54,1.95,7.18,7.18,0,0,1,0-2A6.84,6.84,0,0,1,423.15,333.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.28,328.14a7.12,7.12,0,0,1-2,0,7.55,7.55,0,0,1-1.95-.54,7.18,7.18,0,0,1,2,0A7.48,7.48,0,0,1,414.28,328.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.26,311.09a7.17,7.17,0,0,1,1.41,1.45,6.83,6.83,0,0,1,1,1.75,7.12,7.12,0,0,1-1.41-1.44A7.2,7.2,0,0,1,413.26,311.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.81,324a7.17,7.17,0,0,1,1.45-1.41,6.83,6.83,0,0,1,1.75-1,7.12,7.12,0,0,1-1.44,1.41A7.2,7.2,0,0,1,419.81,324Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.16,340a7.17,7.17,0,0,1,1.45-1.41,7,7,0,0,1,1.75-1,7.12,7.12,0,0,1-1.44,1.41A7.2,7.2,0,0,1,411.16,340Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.37,321.48c-.23,1.76-.51,3.51-.78,5.26-.1-.76-.23-1.5-.4-2.25,0,0-.06,0-.05,0,.08.6.13,1.2.22,1.8l.12.87c0,.06,0,.12,0,.18-.21,1.37-.41,2.73-.58,4.11-.21,1.63-.37,3.27-.54,4.91s-.19,3.58-.42,5.27a11.35,11.35,0,0,0,2.12-.08c.2,0,.22-.21,0-.17s-1.86-.05-1.89-.06c.17-1.64.51-3.28.72-4.92s.44-3.27.62-4.91c.36-3.33.53-6.68.88-10C406.44,321.44,406.37,321.44,406.37,321.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.34,323.69c0,.65,0,1.31.07,2,0,.27,0,.53.07.8q-.94-3.12-1.9-6.22s0,0,0,0c.86,3.46,1.71,6.91,2.63,10.34A100.52,100.52,0,0,0,426,340.4a12.42,12.42,0,0,0-1.91.34,8.85,8.85,0,0,0,2.24-.11,106.56,106.56,0,0,0-2.74-10.35c-.27-.94-.55-1.87-.83-2.81-.08-.61-.11-1.22-.15-1.84s-.14-1.3-.22-1.95C422.41,323.65,422.34,323.65,422.34,323.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.13,337.82c-3.12-.05-15.92.23-18.68.47-.2,0-.23.14,0,.15a171.74,171.74,0,0,0,18.71-.5C424.2,337.93,424.21,337.82,424.13,337.82Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-4--inject-86"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 330.52,
    y: 107.3,
    width: 85.64,
    height: 85.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.66,193.44H330V106.8h86.64Zm-85.64-1h84.64V107.8H331Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.92,112.38a2.52,2.52,0,1,1-2.52-2.52A2.52,2.52,0,0,1,339.92,112.38Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347.69,
    cy: 112.38,
    r: 2.52,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 357.99,
    cy: 112.38,
    r: 2.52,
    style: {
      fill: "#138DE8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.52,
    y: 116.82,
    width: 85.64,
    height: 1,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.52,
    y: 107.3,
    width: 85.64,
    height: 85.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.66,193.44H330V106.8h86.64Zm-85.64-1h84.64V107.8H331Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.92,112.38a2.52,2.52,0,1,1-2.52-2.52A2.52,2.52,0,0,1,339.92,112.38Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347.69,
    cy: 112.38,
    r: 2.52,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 357.99,
    cy: 112.38,
    r: 2.52,
    style: {
      fill: "#138DE8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.52,
    y: 116.82,
    width: 85.64,
    height: 1,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.44,120.72c-4.82,6.22-5.24,15.49-5.24,15.49s-4.14,9.82-2,14.57a9.09,9.09,0,0,0,6.54,5.37l-.88-2.67s2.23,3.29,8.36,4,13.76-2.19,17.59-4.79a15.82,15.82,0,0,0,5.33-6.06l-1,4.18a11.92,11.92,0,0,0,8.38-7.53c2.64-6.58-8.35-14.14-9.43-15.93s-3.92-15.51-18.19-11.24C377.86,116.06,371.77,116.44,368.44,120.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.56,156.07a9.46,9.46,0,0,1-4.37-3.54,8.54,8.54,0,0,1-1.62-5.34,18.88,18.88,0,0,1,1.95-6.5c.93-2.15,2-4.23,2.91-6.39.05-.12-.13-.19-.2-.1a53.29,53.29,0,0,0-3,5.24A24.6,24.6,0,0,0,359,144.7a9.17,9.17,0,0,0,0,5.19,9,9,0,0,0,2.31,3.6,19.33,19.33,0,0,0,4.2,2.71C365.6,156.25,365.66,156.1,365.56,156.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.89,136.76c-2.4-4.88-7.4-7.52-10.76-11.61-1.83-2.21-3.34-4.73-5.57-6.57-.06,0-.15.06-.09.11,1.85,1.67,3.08,3.82,4.52,5.82A38.26,38.26,0,0,0,399.1,130c3.34,3.09,7.32,6.74,7.29,11.67,0,2.28-1,4.93-3.23,5.92-.08,0,0,.18.07.13a7.24,7.24,0,0,0,3.49-4.53A9.19,9.19,0,0,0,405.89,136.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.28,138.1a9.52,9.52,0,0,0-2-5.37,13.52,13.52,0,0,0-4.67-3.34c-2-1-4.05-1.88-5.46-3.66-.06-.07-.16,0-.1.1,2.24,2.94,5.93,4,8.63,6.33,3.1,2.7,3.67,7.14,2.26,10.87a15.53,15.53,0,0,1-4.18,5.92,0,0,0,0,0,0,.05C404,146.29,406.56,142.43,406.28,138.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.06,129.77l5.25,22.95c.23.67-.12,1.21-.78,1.19l-11.77-.26a1.89,1.89,0,0,1-1.61-1.25l-5.24-22.94c-.23-.68.12-1.21.77-1.2l11.78.26A1.88,1.88,0,0,1,345.06,129.77Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.67,129.73l5.24,22.94c.23.68-.12,1.21-.77,1.2l-11.78-.26a1.91,1.91,0,0,1-1.61-1.25l-5.24-23c-.23-.67.12-1.21.78-1.19l11.77.26A1.89,1.89,0,0,1,343.67,129.73Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.42,130.7a1,1,0,1,0,1-1A1,1,0,0,0,340.42,130.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.26,165.16C375.4,179.27,360.2,197.5,354,197.5c-2.95,0-8.22.63-12-2.8-8.34-7.5-15.2-21.72-16.53-29.83C325,162,339,156,341.08,158.32c4.76,5.54,10.24,16.38,11.1,16.33,3.17-.2,15.7-10.36,24.45-17.51C387.24,148.46,385,159.54,382.26,165.16Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.29,150c1.56-5.82,2.85-7.08,1.56-12.69-.85-3.68,1.14-5.8,3.7-2.82,4.19,4.87,3.76,12.8,2.81,15.51Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.09,167.39s-2.5-8.17-1.45-14.54c.72-4.4,3.36-13.8,15.78-18.62,2.94-1.14,7.95-.68,3.82,2.93-2.94,2.57-5.57,3.31-7,5.11,0,0,6.3,1.34,7.33,4.34a58.06,58.06,0,0,1,2.13,8,12.81,12.81,0,0,1-1.46.53S346.1,158,344,162Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326,148.76c1.8-1.49,5.68-4.58,9.73-6,4.49-1.58,13.58-3.42,14.72-.09.83,2.45-2.58,3.45-2.58,3.45s3.92,0,4.19,2.41c.24,2.16-2.44,2.78-2.44,2.78s2.37.43,2.21,2.55c-.2,2.56-5.14,1.25-7.58,3.66C343.7,158.06,326,148.76,326,148.76Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.61,147.79a18.92,18.92,0,0,1,11.19-1.74c.09,0,.13.1,0,.1a46.83,46.83,0,0,0-11.22,1.68S336.59,147.8,336.61,147.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.34,152.28a21.26,21.26,0,0,1,11.27-1.07c.1,0,.13.11,0,.11a49.83,49.83,0,0,0-11.3,1S338.32,152.29,338.34,152.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.39,168.05l14.52,10.77s7.07-9.53,8.74-18-2.66-8.55-9.2-3.36S361.39,168.05,361.39,168.05Z",
    style: {
      fill: "#138DE8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.64,166.51c.84.4,7.89,5.47,12.58,9.24.06.06,0,.15-.07.11-2.68-1.43-9.31-6.47-12.59-9.26C364.5,166.55,364.58,166.48,364.64,166.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.65,160.77c-1.66,8.52-8.74,18-8.74,18l-9.7-7.19,14.63-17.45C384.11,153.07,385.8,154.93,384.65,160.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.57,187.09c-5.71-11.9-12.85-24.85-19.36-31.09-.31-.3-.63-.59-.94-.85l-.18-.16c-6.33-5.37-13-2.81-17.27,1.61-1,1.1-12.25,19.25-12.73,25.78-.3,4.08,1.84,8.11,3.12,10.13h47.36Z",
    style: {
      fill: "#138DE8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.57,169.56c-6.1-5.67-12.45-10.63-16.61-13.07-4.7-2.75-12.95-4.56-5,7.9,4.66,7.28,12.23,20.63,15.83,28.12h5.76Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,178.36,413.16,166s-8.09-8.68-16.17-11.85-8.89,1.07-5,8.43S400,178.36,400,178.36Z",
    style: {
      fill: "#138DE8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399,174.9c.54-.76,6.81-6.78,11.36-10.71.07-.05.15,0,.1.09-1.9,2.38-8.05,8-11.39,10.71C399,175,399,175,399,174.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.44,176.89c-.1,0-1.42.87-1.5.94-.1-.23-.23-.45-.35-.69l-.77-1.54c-.59-1.13-1.19-2.24-1.82-3.35-1.23-2.16-2.57-4.3-3.7-6.52,0-.09-.18,0-.13.09.62,1.17,1.2,2.38,1.76,3.59-.09-.08-1.4-1.13-1.61-1.34s-.19.05-.11.12c.23.17,2,1.95,2.09,2l1.07,2.28q.79,1.67,1.65,3.3c.27.51.54,1,.82,1.52s.84,1.45.85,1.47a20.89,20.89,0,0,0,1.87-1.74A.11.11,0,0,0,401.44,176.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.81,150.72c-2.63.27-5.73,2.12-8.19,5.45-2.16,2.93-4.14,7.1-2.65,8,1.71,1,5.1-2.77,5.1-2.77s-.86,6.13,2.4,5.82c3.81-.36,7.29-5.66,7.93-9.25C391.08,154.09,390.39,150.25,385.81,150.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.56,154c-.26.89-4.89,6.53-9,6.12-1.34-.14-.92-7.5-.92-7.5l-.09-.55-1.3-7.71,9.25-5.27,1.34-.69s.21,2.13.46,4.79l0,.38c0,.15,0,.29.05.43,0,.4.08.8.11,1.21s0,.6.07.93l.06,1A52.05,52.05,0,0,1,389.56,154Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.28,143.16a15.71,15.71,0,0,1-9.75,8.88l-1.3-7.71,9.25-5.27,1.34-.69S389,140.5,389.28,143.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.8,133.22c-.7,13.7,7.43,15.66,10.39,15.81,2.68.13,11.83.24,13.93-13.31s-4.05-18.21-10.16-18.84S367.49,119.52,366.8,133.22Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.43,131.26a7.21,7.21,0,0,0,.92-.21,1.52,1.52,0,0,0,.9-.4.48.48,0,0,0,0-.59,1.21,1.21,0,0,0-1.2-.26,1.72,1.72,0,0,0-1.1.65A.51.51,0,0,0,369.43,131.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.93,131.37a7.42,7.42,0,0,1-.94-.18,1.52,1.52,0,0,1-.91-.36.48.48,0,0,1,0-.59,1.2,1.2,0,0,1,1.19-.31,1.74,1.74,0,0,1,1.12.61A.52.52,0,0,1,378.93,131.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.17,134.87s.07,0,.07.08c0,.93.08,2,.93,2.32,0,0,0,.06,0,.06C377.13,137.18,377,135.75,377.17,134.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378,133.9c1.51-.11,1.61,2.9.22,3S376.74,134,378,133.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.6,134c.27.17.54.46.86.48s.63-.3.86-.62c0,0,.05,0,.05,0,0,.57-.17,1.17-.78,1.28s-1-.4-1.15-1C378.41,134.13,378.49,134,378.6,134Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.3,134.65s-.07,0-.07.08c.07.94,0,2-.83,2.36,0,0,0,.06,0,0C371.43,137,371.52,135.52,371.3,134.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.43,133.71c-1.51-.05-1.5,3-.1,3S371.69,133.75,370.43,133.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.8,133.91c-.24.16-.47.45-.76.47s-.57-.3-.78-.61c0,0-.05,0-.05,0,0,.58.18,1.18.73,1.29s.88-.4,1-1C370,134,369.9,133.85,369.8,133.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377,142.05c-.21.23-.41.55-.74.61a2.57,2.57,0,0,1-1-.16s-.06,0,0,.05a1.26,1.26,0,0,0,1.23.41,1,1,0,0,0,.66-.88C377.06,142,377,142,377,142.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373,138.76s-.16,1.4-.15,2.06c0,.06.16.09.39.09h0a3.1,3.1,0,0,0,3-1.24c.05-.06,0-.13-.1-.08a4.75,4.75,0,0,1-2.84.88c-.05-.18.36-2.39.25-2.39a5.94,5.94,0,0,0-1.48.37c.25-2.92,1-5.78,1.17-8.7,0-.1-.15-.13-.18,0a47.46,47.46,0,0,0-1.65,9.32C371.37,139.41,372.71,138.88,373,138.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.3,140.67a3.91,3.91,0,0,0,1.52,1.2,1.7,1.7,0,0,0,1.05.07c.76-.19.78-.88.65-1.48a4.19,4.19,0,0,0-.33-.91A5,5,0,0,1,373.3,140.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.82,141.87a1.7,1.7,0,0,0,1.05.07c.76-.19.78-.88.65-1.48A1.79,1.79,0,0,0,374.82,141.87Z",
    style: {
      fill: "#ff99ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.9,136.38c-3.37,0-4.7-10.32-4.85-11.59.05.8.31,5.06,0,5.24a3.31,3.31,0,0,1-1.07-.16h0a10.1,10.1,0,0,0-.17-1.52c0-.24-.07.51-.17,1.44l-.63-.16a12.14,12.14,0,0,0-.43-3.23c-.11-.39-.16,1.42-.49,3a40.7,40.7,0,0,0-8.87-1.26c-.84,0-1.57,0-2.21.08a19,19,0,0,0,0-2.31,11.83,11.83,0,0,0-.44,2.35l-1,.11c-.14-1.78.61-4.64.34-4.2a12.34,12.34,0,0,0-1.57,4.44c-1.21.27-1.54.52-1.58.21a14.8,14.8,0,0,1,4.2-9.34c4.08-4.11,12.44-5.38,17.38.56,0,0,4,2.42,4.74,6.5S391.85,136.38,389.9,136.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.41,136.38s2.84-4.39,4.82-3.39,0,7.28-2.29,8.21a2.33,2.33,0,0,1-3.16-1.13Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.61,134.78s0,0,0,.06a5.87,5.87,0,0,0-2.9,3.77,1.29,1.29,0,0,1,1.91-.42s0,.1-.05.09a1.43,1.43,0,0,0-1.55.56,7,7,0,0,0-.7,1.29c-.07.15-.33.08-.28-.09v0C388.94,138,390.42,135.06,392.61,134.78Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-86"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 200.01,
    y: 213.21,
    width: 85.64,
    height: 85.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.15,299.35H199.51V212.71h86.64Zm-85.64-1h84.64V213.71H200.51Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.41,218.3a2.52,2.52,0,1,1-2.52-2.53A2.52,2.52,0,0,1,209.41,218.3Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.7,218.3a2.52,2.52,0,1,1-2.52-2.53A2.52,2.52,0,0,1,219.7,218.3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 227.47,
    cy: 218.3,
    r: 2.52,
    style: {
      fill: "#138DE8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.01,
    y: 222.73,
    width: 85.64,
    height: 1,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.14,248.41c-2.83-6.11-6.79-10.14-7.57-9.86-1,.35-12.14,25.63-13.32,26.53s-6.75-1.47-17.16-5.82-9.9,3.54-2.69,11.58,19,15.86,28,14.41c5.4-.86,9.93-9.38,12.7-16.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.52,284.21c-6.95-2.35-14.14-7.8-19.12-13.37-6.3-7-7.49-13.92-.75-12.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.21,265.27c-3,1.1-8.93-3.06-11.49-6.69-.17-.25-.08-3.09-.14-6.54,0-2.1-.13-4.43-.37-6.56-.06-.43,1.52.2,1.52.2l2.82.35,9.34,1.18a34.21,34.21,0,0,0-.36,8.29,4.61,4.61,0,0,0,.19.87,1.06,1.06,0,0,1,0,.14C244.21,258.13,245.15,264.22,242.21,265.27Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.72,256.37a1.06,1.06,0,0,1,0,.14,9.85,9.85,0,0,1-1.36.23c-9,.81-11.4-10.46-11.4-10.46l3.56-.25,9.34,1.18a34.21,34.21,0,0,0-.36,8.29A4.61,4.61,0,0,0,243.72,256.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.13,229.1c-1.25,4.81,1.84,18.42,5.35,21.33,5.08,4.23,13.12,4.31,16.63-1.73,3.41-5.86-.93-23.53-4.82-26.14C238.56,218.7,229,222,227.13,229.1Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.13,250.31h0",
    style: {
      fill: "none",
      stroke: "#f3a59c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.81,237.24s-.06.06-.05.1c.23.91.34,2-.42,2.48,0,0,0,.06,0,.05C239.34,239.5,239.18,238.06,238.81,237.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.78,236.46c-1.5.22-1,3.2.43,3S239,236.28,237.78,236.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.4,236.05s.08,0,.08.07c.14.93.46,2,1.35,2.13,0,0,0,.05,0,.05C244.78,238.35,244.38,237,244.4,236.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.05,234.94c1.46-.38,2.12,2.58.76,2.93S243.82,235.26,245.05,234.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.35,235.31a10.43,10.43,0,0,0,1.08-.62,2,2,0,0,0,1-.84.65.65,0,0,0-.24-.74,1.58,1.58,0,0,0-1.61.12,2.34,2.34,0,0,0-1.14,1.24A.68.68,0,0,0,236.35,235.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.93,233.23c-.43,0-.82-.06-1.24-.1a2,2,0,0,1-1.25-.33.65.65,0,0,1-.11-.78,1.61,1.61,0,0,1,1.51-.58,2.32,2.32,0,0,1,1.56.63A.68.68,0,0,1,245.93,233.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.76,245.81c.26.17.54.43.88.4a2.66,2.66,0,0,0,1-.41s.06,0,0,0a1.28,1.28,0,0,1-1.09.71,1,1,0,0,1-.87-.69C239.65,245.81,239.72,245.78,239.76,245.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.23,242.86a3.19,3.19,0,0,0,2.36,1,4,4,0,0,0,1.14-.15l.21-.07.2-.06a.25.25,0,0,0,.15-.24h0a.24.24,0,0,0,0-.09h0l0-.08c-.11-.72-.37-1.79-.37-1.79.28.08,1.71.44,1.63.07a49.12,49.12,0,0,0-2.95-9.31c0-.09-.2,0-.17.06.6,3,1.71,5.79,2.36,8.75a5.6,5.6,0,0,0-1.57-.19c-.09.05.55,2.06.57,2.39,0,0,0,0,0,0a4.4,4.4,0,0,1-3.44-.42C240.22,242.72,240.16,242.8,240.23,242.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.24,243.56a3.82,3.82,0,0,1-1.35,1.37,1.74,1.74,0,0,1-1,.21c-.77-.1-.88-.78-.82-1.38a4.38,4.38,0,0,1,.21-.94A4.93,4.93,0,0,0,243.24,243.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.89,244.93a1.74,1.74,0,0,1-1,.21c-.77-.1-.88-.78-.82-1.38A1.76,1.76,0,0,1,241.89,244.93Z",
    style: {
      fill: "#ff99ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.39,239.46c3.14-.61,2.66-6.44,2.66-6.44s5.24-1.92,5.25-6.14c0,0,5.75,2.3,9.5.07s2.24-7.14,1.6-8c-1.48-2-4.28,1.48-4.28,1.48a20.1,20.1,0,0,0-11.33-.43c-4.6,1.36-6.11,6.23-6.11,6.23s-2.42,1-2.9,2.94S226.39,239.85,228.39,239.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.79,233.3c4.29-.24,6.53-3.55,6.37-7.67a0,0,0,0,1,.08,0c.59,3.76-2.1,8.58-6.45,7.87A.1.1,0,0,1,229.79,233.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.77,226.1s.09.05,0,.08c-1.07.76-2.33,1.43-2.95,2.65-.75,1.48-.21,3.13.44,4.52,1,2.16,2.74,4.88,5,5.82a.11.11,0,0,1-.09.2c-2.71-1-4.85-4.52-5.69-7.12C221.6,229.33,223.13,227.27,225.77,226.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.09,227.09a5.84,5.84,0,0,0,6.35-1.37c1.89-2.11.91-4.78-.46-6.9-.07-.1.06-.25.15-.16,1.67,1.77,2.34,4.83.87,6.92a6.12,6.12,0,0,1-7,1.82C240.77,227.33,240.9,227,241.09,227.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.47,242.25a4.1,4.1,0,1,1,3.41-5.5h0a4.1,4.1,0,0,1-2.42,5.26A4.46,4.46,0,0,1,238.47,242.25Zm-.81-7.6a3.35,3.35,0,0,0-.86.2,3.56,3.56,0,1,0,.86-.2Z",
    style: {
      fill: "#138DE8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.62,240.12c-1.55.17-3.14-1.28-3.61-3.36a4.94,4.94,0,0,1,.21-3,2.71,2.71,0,0,1,1.86-1.68,2.69,2.69,0,0,1,2.4.72,5,5,0,0,1,1.48,2.6c.5,2.2-.43,4.3-2.07,4.67Zm-1.22-7.53-.2,0a2.22,2.22,0,0,0-1.48,1.37,4.45,4.45,0,0,0-.18,2.65c.44,1.9,1.88,3.21,3.23,2.9s2.08-2.1,1.65-4a4.3,4.3,0,0,0-1.3-2.31A2.28,2.28,0,0,0,246.4,232.59Z",
    style: {
      fill: "#138DE8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.85,237.24l-.44-.33c.49-.64,1.74-1.65,3-.82l-.31.45C243,235.8,241.89,237.18,241.85,237.24Z",
    style: {
      fill: "#138DE8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.11,242.27l-.53-.14c.06-.25.66-2.43,1.81-2.89s7.56-1.35,7.87-1.39l.07.54a72.83,72.83,0,0,0-7.74,1.36C225.83,240.05,225.26,241.67,225.11,242.27Z",
    style: {
      fill: "#138DE8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.54,240.15s-3.38-4.23-5.32-3,.79,7.5,3.21,8.24a2.4,2.4,0,0,0,3.13-1.5Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.05,238.93a0,0,0,0,0,0,.06,6.08,6.08,0,0,1,3.37,3.6,1.33,1.33,0,0,0-2-.24.05.05,0,0,0,.05.09,1.49,1.49,0,0,1,1.66.41,7.87,7.87,0,0,1,.86,1.27c.08.14.34,0,.28-.12l0,0C230.15,241.85,228.33,239,226.05,238.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.79,298.3c-1.84-10.38-4.05-20.67-6.09-25.84a104.59,104.59,0,0,0-7.58-14.69c-.41-.54-.05-2.64-.45-3s-14.48-.93-14.91-.57.38,3.76-.24,4.67c-6.5,5.22-13.23,23-18.18,39.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.14,255.14a10,10,0,0,1,0,3.21,10.79,10.79,0,0,1,0-3.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.9,255.14a10,10,0,0,1,0,3.21,10.79,10.79,0,0,1,0-3.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.66,255.14a10.79,10.79,0,0,1,0,3.21,10.79,10.79,0,0,1,0-3.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.42,255.14a10.79,10.79,0,0,1,0,3.21,10,10,0,0,1,0-3.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.18,255.14a10.79,10.79,0,0,1,0,3.21,10,10,0,0,1,0-3.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.94,255.14a10.79,10.79,0,0,1,0,3.21,10,10,0,0,1,0-3.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.7,255.14a10.79,10.79,0,0,1,0,3.21,9.59,9.59,0,0,1-.13-1.6A10.81,10.81,0,0,1,241.7,255.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.46,255.14a10.79,10.79,0,0,1,0,3.21,9.59,9.59,0,0,1-.13-1.6A10.81,10.81,0,0,1,243.46,255.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.79,264.36a196.57,196.57,0,0,0-21.32,23.08V298.3h25.61c-5.23-1.18-12-2.45-12-2.45A91.77,91.77,0,0,0,229,271.55C235.27,256.58,230.24,257,221.79,264.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.16,273.39a19.34,19.34,0,0,0-2,1.65c-.18.17-.35.36-.52.53.82-1.4,1.63-2.8,2.39-4.23a.09.09,0,0,0-.16-.09c-2.29,3.63-4.53,7.28-6.87,10.88s-4.7,7.07-7.08,10.58c-1.35,2-2.65,4-4,6-.05.07.07.16.12.09,1.32-1.69,2.66-3.33,3.92-5.07s2.41-3.41,3.58-5.14c2.38-3.56,4.67-7.18,6.84-10.87l.64-1.1.57-.48c.31-.27.63-.56.93-.85a19.62,19.62,0,0,0,1.67-1.86S230.2,273.36,230.16,273.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.63,227.57c1,2.69-2.74,2.34-2.74,2.34s5.26,1.81,5.23,5-4.55,2.47-4.87,2.43c.27.1,5.07,1.88,4.7,5.07s-4.8,1.94-5.09,1.85c.24.17,3.28,2.54,2.45,4.9-1.42,4-9.37-1.79-12.77-1.12l.26,5.49c0,.18,0,.45-.05.62l-2.57.36a36.92,36.92,0,0,0-2.89-5c-1.31-2-2.5-4-2.62-5.47a3.14,3.14,0,0,1,1.87-3.25s-2.66-1.47-2.45-4c.11-1.29,2.27-2.26,2.27-2.26a3.74,3.74,0,0,1-1.76-3.49c.25-1.77,2.38-2.47,2.38-2.47s-1.44-2.15-.59-3.88C280.09,221.23,295.47,221.82,297.63,227.57Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.3,248.75l.59,4.64c0,.18,0,.6-.06.78-.74,6.17-7.32,10.32-8.09,5.93-.59-3.33,3.64-7.24,2.54-10.57h0Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.3,228.43c-.05,0-.06-.07,0-.08a26.72,26.72,0,0,1,15.8,1.55c.16.08.11.36-.07.32A54.49,54.49,0,0,0,279.3,228.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.28,234.53c-.06,0-.06-.1,0-.11a25,25,0,0,1,17.14,2.76c.18.11.23.39,0,.28C291.81,235.63,283.25,234.29,278.28,234.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.15,244.58c-5.11-2.82-10.61-3.72-16.39-3.83-.08,0-.07-.11,0-.13,2.84-.71,6.52-.25,9.35.34a15.38,15.38,0,0,1,7.14,3.45C295.33,244.48,295.26,244.64,295.15,244.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285,250.72c-.19-1-.32-1.88-.49-2.85,0-.09-.16-.06-.16,0,0,1.37.16,2.71.2,4.09a12.55,12.55,0,0,1-.57,4.17,9.71,9.71,0,0,1-1.77,3.21,5.1,5.1,0,0,1-3.29,2.11,2.07,2.07,0,0,1-2.08-2.39,8.33,8.33,0,0,1,1.42-3.51,13.46,13.46,0,0,0,1.48-3.72,5.21,5.21,0,0,0-.68-3.38c-.36-.72-.74-1.44-1.11-2.16a7.69,7.69,0,0,1-.85-1.87,3.24,3.24,0,0,1,1.55-3.6.08.08,0,1,0-.06-.15,4.49,4.49,0,0,0-2.31,2.46,4.29,4.29,0,0,0,.62,3.52c.38.73.76,1.45,1.15,2.17a4.52,4.52,0,0,1,.76,2.43,12.25,12.25,0,0,1-1.86,4.61,6.26,6.26,0,0,0-1,3.86,2.9,2.9,0,0,0,2,2.52c2.72.73,5.15-2.25,6.18-4.39a10.49,10.49,0,0,0,.8-4.69A13.61,13.61,0,0,0,285,250.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.14,248.91a7,7,0,0,0-1.85-.84,8.76,8.76,0,0,0-2-.41,5.06,5.06,0,0,0-1.9.15,3.43,3.43,0,0,0-1.48.95.08.08,0,0,0,.08.13,14.7,14.7,0,0,1,1.63-.33,10.14,10.14,0,0,1,1.74-.15,9.55,9.55,0,0,1,1.86.22c.63.12,1.24.33,1.88.41A.07.07,0,0,0,289.14,248.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.41,240.59l-.27-.18a4.41,4.41,0,0,1-.51-.46c-.16-.17-.33-.34-.48-.52l-.25-.27a1.59,1.59,0,0,0-.13-.13,2,2,0,0,1-.12-.19c-.06-.09-.2,0-.14.08s.09.13.12.19a1.46,1.46,0,0,1,.07.19c.05.12.11.24.17.36a3.37,3.37,0,0,0,.47.65,1.92,1.92,0,0,0,.62.43,1,1,0,0,0,.35.11.58.58,0,0,0,.32,0,0,0,0,0,0,0-.07A1.06,1.06,0,0,0,278.41,240.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.86,288.42a3.46,3.46,0,0,1,3.57,1.95s1.29-2.88,3.92-2.88c1.35,0,2.53,2.17,2.53,2.17a3.92,3.92,0,0,1,3.48-2.12c1.86.13,2.76,2.27,2.76,2.27s2.11-1.66,4-.93c3.77,1.48,4.42,17.47-1.37,20.19-2.7,1.26-2.64-2.66-2.64-2.66s-1.44,5.62-4.73,5.84-2.92-4.87-2.92-4.87-1.44,5.43-4.88,5.31-2.33-5.14-2.33-5.14-2.26,3.65-4.88,3c-4.31-1.14.57-8.71-.41-12.19H201S207.49,289.25,213.86,288.42Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.55,293c3.6.59,6.94-4.38,10.46-4.31,4.78.1,1.74,8.16-4.84,9.58l-5.6,0Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.31,290.13a0,0,0,0,1,.09,0,27.87,27.87,0,0,1-.31,16.52c-.06.17-.36.14-.33-.06A56.63,56.63,0,0,0,230.31,290.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.91,289.58c0-.06.1-.07.12,0a26,26,0,0,1-1.46,18c-.1.2-.38.28-.28,0C223.89,303.7,224.56,294.71,223.91,289.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.88,307.9c2.5-5.53,3-11.31,2.62-17.31,0-.08.11-.08.13,0,1,2.89.81,6.74.42,9.73a16,16,0,0,1-3,7.68C215,308.07,214.82,308,214.88,307.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204,294.46c-.06.06,0,.15.1.1,2.71-2.36,10.69-9.2,13.45-4,.1.18.28.26.22,0C216.86,287.32,213.43,285.33,204,294.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.52,287.17a4.15,4.15,0,0,0-3,3.49c0,.12.18.18.22.07a4.84,4.84,0,0,1,2.14-2.7c1.73-.89,3.11.28,4,1.7a.14.14,0,0,0,.25-.1A3.23,3.23,0,0,0,220.52,287.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.52,287.16a3.83,3.83,0,0,0-3.61,2.37c-.11.24.15.24.17.22,1-1,2-2.2,3.53-1.9a4.73,4.73,0,0,1,2.59,2.07c.06.08.17,0,.15-.09A3.2,3.2,0,0,0,227.52,287.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.09,298.32c0,.05-.09.06-.1,0-.65-2.88-.9-9.38-4.27-9.38h0a3.8,3.8,0,0,0-2.37,1s-.08,0-.06,0a2.82,2.82,0,0,1,4.43-.87l.07.07C236.87,291,237.23,296.52,237.09,298.32Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-86"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70.2,
    y: 301.33,
    width: 85.64,
    height: 85.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.34,387.47H69.7V300.83h86.64Zm-85.64-1h84.64V301.83H70.7Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6,306.41a2.52,2.52,0,1,1-2.52-2.52A2.52,2.52,0,0,1,79.6,306.41Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.89,306.41a2.52,2.52,0,1,1-2.52-2.52A2.52,2.52,0,0,1,89.89,306.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.19,306.41a2.52,2.52,0,1,1-2.52-2.52A2.52,2.52,0,0,1,100.19,306.41Z",
    style: {
      fill: "#138DE8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.2,
    y: 310.85,
    width: 85.64,
    height: 1,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.24,364c3.69,7.27,11.89,11.51,19.41,13.63s16.56,3.27,24.36,1.15a19.35,19.35,0,0,0,9.17-5.24c2.61-2.8,3.56-6.13,2.12-9.59-1.16-2.78-4.45-5.29-4-7.52s2.64-3.6,3.59-5.63c1.63-3.48.24-6.63-1.79-9.54-4.81-6.9-1.61-14-3.82-21.77-1.26-4.43-5.64-13-17-11.92-4.31.42-7.86,3.54-10.31,7-2.89,4.1-2.77,10.33-6,14.17-2.8,3.26-5.89,3.23-8.64,6.7-1.19,1.51-2,3.39-1.07,7.74.34,1.57.56,3.9-.39,5.49-1.32,2.19-4.33,2.69-5.77,5C74.13,356.78,74.62,360.77,76.24,364Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.62,374c3.77.16,6.4-4.58,4.63-7.66-1.11-1.95-3.15-3.17-4.27-5.12-1.85-3.19.81-5.17,2.67-7.54,4-5.13,1-9.81-2.34-14.21-2.53-3.34-2.51-6.55-1.89-10.55,0-.06.12-.05.11,0-.32,3-.52,5.93,1,8.63,1.25,2.2,3.16,3.92,4.35,6.18a9,9,0,0,1-1.07,10.64c-.76,1-2,1.93-2.5,3-1.09,2.62.65,4.45,2.3,6.2,1.26,1.33,2.66,2.82,2.84,4.75.26,2.93-3,6.15-5.85,5.86C126.47,374.17,126.46,374,126.62,374Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.05,376.32c2.52-.9,5.21-1.63,7-3.75,2.69-3.12.81-6.3-.94-9.27a5.25,5.25,0,0,1-1-4c.55-2.26,2.58-3.82,3.32-6,1.77-5.24-2.81-9.58-4.64-14.07s-1.77-9.48-1.79-14.34a.08.08,0,0,1,.16,0c.06,6.22.65,12.16,3.86,17.61,2.24,3.8,4.62,7.9,2.31,12.25-.57,1.07-1.45,2-2,3a5.21,5.21,0,0,0,.37,5.64c1.1,1.85,2.41,3.77,2.22,6-.37,4.38-5.17,6.34-8.82,7.29A.19.19,0,0,1,124.05,376.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.41,352.1c2.33-2.23,5.48-3,5.46-6.81,0-2.66-1-5,.06-7.59a10,10,0,0,1,4.61-4.76c2.51-1.45,5.17-2.5,7.2-4.63,2.23-2.33,3.61-5.31,5-8.17,0-.06.13,0,.11,0-1.64,3.94-3.48,8-7.17,10.41-1.92,1.29-4.11,2.11-6,3.42-3.44,2.34-4,5.54-3.51,9.42.24,1.79.41,3.56-.68,5.12s-2.9,2.29-4.3,3.49c-6,5.11-.12,14.22,5.71,16.51.26.1.15.52-.12.42-4.39-1.58-8.38-6.65-8.51-11.35A7.35,7.35,0,0,1,75.41,352.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,355.38c.58-2.7,2.54-3.88,4.25-5.75,2.68-2.95,1.2-6.65,1.63-10.23a8.93,8.93,0,0,1,3.54-5.89c2.5-2,5.42-3.24,7.62-5.69a18,18,0,0,0,4.31-9.37c0-.06.1,0,.1,0a17.06,17.06,0,0,1-6.8,12c-2.46,1.8-5.55,3.06-7.25,5.79-1.8,2.89-.79,6-1,9.23a7,7,0,0,1-2.32,5,14.3,14.3,0,0,0-3,3.19,8.62,8.62,0,0,0-.56,5.92c1.35,6.16,6.61,10.88,12.1,12.89.19.07.11.4-.08.33a20.13,20.13,0,0,1-11.48-10.32A11.64,11.64,0,0,1,75,355.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.84,352c4,5.21,25.45,21.93,44.06,22.26,6.32.11,24.79-26.26,28.38-36.41,2.58-7.29-12.94-11.53-17.39-10.62-5.56,1.14-15.28,23.74-19.22,24-6.32.41-18.28-3.67-31.48-6C101.4,344.1,100.8,348,103.84,352Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.81,339c1.09-2.18,5.2-12.61,5.7-15.77s1.25-12.35-1.13-13-2.81,2-2.81,2-.3-3.93-2.75-4.34-3,3.77-3,3.77-.59-4-3.07-4.25-2.32,4.06-2.32,4.06-.37-3.69-2.49-3c-2.56.8-1.1,7.54-1.91,11-.18.78-4.84,15.59-4.84,15.59Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.42,311.16c1.06,4.95.67,7.31-1,12,0,.09.09.16.13.07,2.11-4.43,3-7.31,1.16-12.13C166.57,310.86,166.37,310.92,166.42,311.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.73,311.32c.65,5.25.25,7.8-1.2,12.84,0,.07.1.11.13,0,1.83-4.82,2.68-7.72,1.34-12.87C171.94,311.1,171.7,311.08,171.73,311.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.48,312.54c.27,5.12-.06,7.94-2.09,12.66a.09.09,0,0,0,.17.08,17,17,0,0,0,2.08-12.73C177.58,312.23,177.47,312.22,177.48,312.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.74,337.28a62.12,62.12,0,0,1-.09-9.17c.4-2.83,5.76-12.83,8-11.79,2.87,1.33.91,7.72-.46,10.72,0,0,6.66,3.09,6.24,8S153.74,337.28,153.74,337.28Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.31,316.94c1.74,3.11-.31,6.94-1.42,9.95a.29.29,0,0,0,.26.41c2.7,1.48,6.08,4.35,6.43,7.58,0,.1.14.1.14,0,.1-3.52-3-6.61-6.05-8,1.19-3.07,3.07-7,.67-9.91C162.32,316.91,162.3,316.92,162.31,316.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.21,341.12l22,14.47s-11.85,17.82-18.85,19.35S119.56,367.6,107.93,357s-7.16-14.25,5.3-11.34,24.45,5.37,26.4,4.49S146.21,341.12,146.21,341.12Z",
    style: {
      fill: "#138DE8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.18,372.37c-9.21-3.24-20.26-9-27.25-15.34-10.64-9.67-7.81-13.58,2.28-11.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.65,386.48v-.12s4.45-5.7,4-11.46c-.49-6.54-11.7-24.68-12.74-25.78-4.22-4.42-10.41-7.28-18.39-.6-8.34,7-17,24.36-23,38Z",
    style: {
      fill: "#138DE8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.68,386.48c3.23-7.64,9-19.51,12.57-26.63,6.61-13.24-3.44-14-7.25-10.08-7.48,7.63-20.47,21.74-26.3,32.47v4.24Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,386.48c3.22-7.36,9-20,12.59-27.34,5.24-10.77-.68-17.86-10.15-8.76-7.58,7.29-18.93,21.74-24.73,31.79v4.31Z",
    style: {
      fill: "#138DE8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.41,386.48c.24-.49.46-.94.6-1.26.87-2,1.75-4,2.6-6.06s1.73-4.05,2.54-6.1c.14-.35.29-.69.43-1,.19-.14,1.78-2.42,2.23-2.92.08-.08-.06-.2-.12-.12a13,13,0,0,1-1.36,1.51l-.24.29c.55-1.32,1.1-2.65,1.61-4,0-.1-.1-.17-.14-.08-1.19,2.74-2,4.39-3.07,6.55s-1.92,4.24-2.86,6.37-1.84,4.28-2.74,6.43c0,.11-.11.24-.17.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.2,346.48c.26.9,4.89,6.54,9,6.13,1.34-.14.92-7.5.92-7.5l.09-.55,1.3-7.71-9.25-5.27-1.34-.69s-.21,2.13-.45,4.79c0,.12,0,.25,0,.38s0,.29,0,.43c0,.4-.08.8-.11,1.21s-.05.6-.07.93l-.06,1A51.88,51.88,0,0,0,104.2,346.48Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.49,335.68a15.68,15.68,0,0,0,9.74,8.88l1.3-7.71-9.25-5.27-1.34-.69S104.73,333,104.49,335.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.07,330.34s-3.6-3.78-5.36-2.43,1.39,7.14,3.78,7.64a2.31,2.31,0,0,0,2.88-1.7Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.65,329.55s0,.05,0,.06a5.88,5.88,0,0,1,3.55,3.17,1.29,1.29,0,0,0-2-.06s0,.1.06.08a1.4,1.4,0,0,1,1.62.26,6.87,6.87,0,0,1,.94,1.14c.09.13.34,0,.26-.14l0,0C103.84,332,101.85,329.42,99.65,329.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.14,322.86c3.23,13.34-4.4,16.77-7.27,17.46-2.61.63-11.58,2.44-16.17-10.49s.6-18.64,6.49-20.39S121.92,309.53,125.14,322.86Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.19,321.43c-.32,0-.62,0-1,0a1.56,1.56,0,0,1-.95-.22.48.48,0,0,1-.1-.59,1.21,1.21,0,0,1,1.13-.48,1.8,1.8,0,0,1,1.2.43A.52.52,0,0,1,122.19,321.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.88,323.3c.31-.09.58-.23.88-.35a1.5,1.5,0,0,0,.83-.53.47.47,0,0,0-.1-.58,1.19,1.19,0,0,0-1.22-.08,1.81,1.81,0,0,0-1,.8A.53.53,0,0,0,112.88,323.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.26,326.4s-.07.06-.06.1c.21.91.29,2-.48,2.45,0,0,0,.06,0,.05C115.72,328.67,115.6,327.24,115.26,326.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.25,325.61c-1.49.17-1,3.15.35,3S115.51,325.46,114.25,325.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.69,325.85c-.23.21-.44.55-.75.63s-.68-.18-1-.45c0,0-.06,0,0,.05.08.57.39,1.12,1,1.11s.9-.57,1-1.17C113.9,325.91,113.79,325.77,113.69,325.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,325.1s.08,0,.08.07c.1.93.38,2,1.26,2.16,0,0,0,.05,0,.05C121.28,327.39,120.93,326,121,325.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.66,324c1.47-.33,2,2.63.66,2.94S120.43,324.29,121.66,324Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.32,324.1c.26.11.54.35.83.32s.51-.41.66-.75c0,0,0,0,0,0,.12.57,0,1.19-.48,1.4s-.94-.23-1.18-.77C122.16,324.22,122.21,324.05,122.32,324.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.79,333.42c.25.19.5.47.84.46a2.49,2.49,0,0,0,1-.34s.06,0,0,0a1.23,1.23,0,0,1-1.12.63,1,1,0,0,1-.82-.74C116.69,333.42,116.76,333.39,116.79,333.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.1,329.45a20.13,20.13,0,0,1,.52,2c0,.06-.14.11-.36.16h0a3.15,3.15,0,0,1-3.19-.66.07.07,0,0,1,.08-.11,4.63,4.63,0,0,0,3,.34c0-.18-.79-2.27-.69-2.3a5.83,5.83,0,0,1,1.53.09c-.79-2.83-2-5.5-2.76-8.33a.09.09,0,0,1,.16-.07,47.65,47.65,0,0,1,3.36,8.85C121.79,329.79,120.38,329.52,120.1,329.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.13,331.38a3.78,3.78,0,0,1-1.27,1.47,1.74,1.74,0,0,1-1,.27c-.78-.05-.94-.73-.92-1.34a4.33,4.33,0,0,1,.16-1A4.92,4.92,0,0,0,120.13,331.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.86,332.85a1.74,1.74,0,0,1-1,.27c-.78-.05-.94-.73-.92-1.34A1.79,1.79,0,0,1,118.86,332.85Z",
    style: {
      fill: "#ff99ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.65,330.59c2.24-.29,1.77-5,1.77-5s4.48-.93,4.6-7.67a10.18,10.18,0,0,1-.86,5.74s7.71-2.5,9.64-9.8c0,0-.61,3.64-1.6,5.1a9.46,9.46,0,0,0,4.16-4.65s2.18,3.52,3.47,4.35c0,0-3.24-13.74-15.72-9.58,0,0-7.89,2.22-9.43,9.17S102.65,330.59,102.65,330.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105,344.53a16.39,16.39,0,0,0-7.79,4.33s8.81,5.49,16.1,4.21c3.28-.58,5-6.11,5-6.11S111.83,343.62,105,344.53Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.43,350.36a42,42,0,0,0,6.23,3,24.72,24.72,0,0,0,6.63,1.66,14.7,14.7,0,0,0,3.38,0,11.5,11.5,0,0,0,1.65-.34,4.71,4.71,0,0,0,1.45-.73,9.86,9.86,0,0,0,2.26-2.5,19.84,19.84,0,0,0,1.66-3,12.54,12.54,0,0,1-3.57,6,4.55,4.55,0,0,1-1.61.9,11.54,11.54,0,0,1-1.74.4,15.07,15.07,0,0,1-3.55.09,22.9,22.9,0,0,1-6.78-1.86A28.51,28.51,0,0,1,96.43,350.36Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-86"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75.36,
    y: 138.84,
    width: 85.64,
    height: 85.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.5,225H74.86V138.34H161.5Zm-85.64-1H160.5V139.34H75.86Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.76,143.92a2.52,2.52,0,1,1-2.52-2.52A2.52,2.52,0,0,1,84.76,143.92Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.53,
    cy: 143.92,
    r: 2.52,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.83,
    cy: 143.92,
    r: 2.52,
    style: {
      fill: "#138DE8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.36,
    y: 148.36,
    width: 85.64,
    height: 1,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,192c5.73,13.78,17.85,30.62,25.37,29.34,6.87-1.16,21.27-11,27.08-16s-10.63-18.85-14.13-16c-4.67,3.84-12.51,12-14,11.71-1.89-.3-4.12-2.89-16.4-14.37C104.82,182,99.51,186.11,102,192Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.37,182.34c2.95-1.38,6.22-3.21,9.61-3.48s6.66,3.92,6.79,5.21-.36,9.4-3.75,9.74-2-6-2.15-6.7-.42-1.58-1.05-1.45-11.3,6.56-11.3,6.56Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.64,182.79c.19,0,8.92-4.51,12.32-4.79s6.66,3.93,6.79,5.21-.36,9.41-3.75,9.74-2-6-2.16-6.7-.41-1.57-1.05-1.45-11.3,6.56-11.3,6.56Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.8,192.64a4,4,0,0,1-.76-1.95,6.92,6.92,0,0,1-.09-2.18,12.29,12.29,0,0,0,.22-1.9,3.7,3.7,0,0,0-.65-1.75c-.31-.45-.79-.24-1.2,0a16.05,16.05,0,0,0-1.76,1c-.62.39-1.23.79-1.84,1.19a18,18,0,0,0-1.86,1.27s0,.12,0,.09c.57-.26,1.1-.62,1.65-.94s1.23-.73,1.85-1.08,1.14-.7,1.73-1c.2-.11.61-.38.86-.35s.46.65.54.85a3.24,3.24,0,0,1,.06,1.85,9.22,9.22,0,0,0-.16,1.89,4.93,4.93,0,0,0,.31,1.75,7,7,0,0,0,1,1.38C160.75,192.78,160.86,192.7,160.8,192.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.76,192.76s8.55-9.5,10.34-11.4c3.58-3.8,19.44-12.2,21.72-12.67s3.59,4.16-7.15,10.19c-5.65,3.17-6.37,6.66-6.07,8.53s2.44,5.18,5.59,4.78,4.74-5.21,7.59-6,1.46,4.71-.28,8a19.5,19.5,0,0,1-7.84,7.47c-2.62,1.3-10.71,5.78-10.71,5.78Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.89,189.59c-1.1,1-2.33,2.36-3.89,2.58s-2.76-.73-3.65-2a6,6,0,0,1-1.26-4.28,7.32,7.32,0,0,1,1.81-3.76,18.18,18.18,0,0,1,4-3.27c.07,0,0-.14-.07-.1-1.39.8-5.72,3.09-6.23,7.18a6.18,6.18,0,0,0,1.32,4.36,4.44,4.44,0,0,0,3.51,2.27c1.88,0,3.34-1.71,4.56-3C165,189.56,164.94,189.53,164.89,189.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.65,195.07a65,65,0,0,0,7.89,15.81c.69,1,1.1,1.45,1.1,1.45l11.84-12.7,1.64-1.76s-.31-.34-1.3-1.26c-1.4-1.29-4.18-3.71-9.41-7.88a27.76,27.76,0,0,0-7.66-4.68C100.08,182.08,98.68,186.64,101.65,195.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.26,212.26l3.91,4.45,13.2-14.43,2.95-3.24-4.65-3.34-.85.91-1.66,1.79-11.62,12.48Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.65,195.07a65,65,0,0,0,7.89,15.81l-1.28,1.38,3.91,4.45,13.2-14.43-2.89-2.65-1.32-1.23c-5.94-5.49-11.86-11-15.41-14.35C100.08,182.08,98.68,186.64,101.65,195.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.28,224.07a171.25,171.25,0,0,0-3.38-23.51c-1.39-5.88-8.17-14.33-8.44-14.57-4-3.58-8.9-4.56-14.08.62-6.64,6.65-14.54,24.07-20,37.46Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.76,197.76C104.6,211.1,130,233.91,138.47,234c9.83.06,32.38-16.28,37.05-22.65,1.87-2.53-15-14.46-17.65-12.4-11.15,8.61-21,12.91-22.92,12.32-3-.91-17.39-11.13-26.85-18.09C96.21,184.4,94.69,191.78,97.76,197.76Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175,211.88c1.16-.88,8.08-10.22,9.77-14.11a41.41,41.41,0,0,0,3.53-12.88c.7-7,.53-12-.75-13.8-1.49-2.13-1.83-2.45-4.79,9.8-1.68,6.93-4.82,8.64-7.74,9.5a49.54,49.54,0,0,0-19.28,10.77S170.55,215.25,175,211.88Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.62,163.91l-8,22.53c-.24.67.1,1.2.75,1.2l11.63-.08a1.88,1.88,0,0,0,1.6-1.21l8-22.54c.24-.67-.1-1.2-.75-1.2l-11.63.09A1.85,1.85,0,0,0,174.62,163.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.58,164l-8,22.54c-.23.66.1,1.2.75,1.19l11.63-.08a1.87,1.87,0,0,0,1.61-1.21l8-22.54c.24-.66-.09-1.19-.74-1.19l-11.63.08A1.91,1.91,0,0,0,173.58,164Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.91,165.09l-7.36,20.66c-.22.64.07,1.14.65,1.14l10.4-.07a1.77,1.77,0,0,0,1.47-1.15L186.43,165c.46-1.29.08-1.57-.5-1.56h-2.08c-.12,0-.27.14-.33.31l0,.08c-.14.4-.36.4-.63.4l-4.82,0c-.27,0-.49,0-.34-.39l0-.08c.06-.17,0-.31-.11-.31l-2.08,0C174.94,163.51,174.33,163.91,173.91,165.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,163.76h1.32a.13.13,0,0,0,.11-.08h0a.06.06,0,0,0-.06-.08H180a.12.12,0,0,0-.11.08h0A.05.05,0,0,0,180,163.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.41 177.25 180.25 177.19 183.41 168.32 174.57 168.39 171.41 177.25",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.58 178.68 179.74 178.64 179.92 178.12 174.76 178.16 174.58 178.68",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.32 179.54 179.43 179.5 179.52 179.24 173.42 179.28 173.32 179.54",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.15 180.02 179.26 179.97 179.35 179.72 173.25 179.76 173.15 180.02",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.98 180.49 179.09 180.45 179.19 180.19 173.08 180.23 172.98 180.49",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.46 165.55 176.56 165.54 176.64 165.33 175.54 165.34 175.46 165.55",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.32 165.95 176.42 165.94 176.5 165.72 175.4 165.73 175.32 165.95",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.18 166.34 176.28 166.33 176.36 166.12 175.26 166.12 175.18 166.34",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.05,178.56a.58.58,0,0,0,.19.26,1.45,1.45,0,0,0,.39-.27c.24-.2.31-.49.1-.49s-.3.24-.3.24,0-.24-.12-.23S171,178.35,171.05,178.56Z",
    style: {
      fill: "#138DE8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.57 184.82 176.7 184.77 177.43 182.72 170.3 182.77 169.57 184.82",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.45,189.89c-3,1,4.85-8.17,3.92-11.63s-3.91-1.34-5.93,1.42c-7,9.55-14,11.39-16.57,19.24S176.45,189.89,176.45,189.89Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.89,207.86c1,.51,2,1.08,3,1.62a16.32,16.32,0,0,0,2.79,1.43,5.09,5.09,0,0,0,3.41-.35c1-.36,1.93-.79,2.86-1.24a92.71,92.71,0,0,0,11-6.41,63.78,63.78,0,0,0,5.82-4.07l-.19.3a15.53,15.53,0,0,1,1.32-3.07,17.59,17.59,0,0,1,2.25-3.16,32.07,32.07,0,0,1,2.94-2.89c.55-.48,1.09-1,1.65-1.4l.84-.68c.25-.2.85-.55,1-.83-.05.12-.22,0-.14-.08l0,0a.07.07,0,0,1,.1,0l.06,0s0,0,0,.07c-.07.18-.27.3-.41.44l-.75.76c-.47.48-.93,1-1.4,1.41-1.06,1.05-2.13,2.11-3.11,3.22a28.33,28.33,0,0,0-2.34,3c-.36.53-.68,1.1-1,1.65a11.22,11.22,0,0,0-.77,1.69c0,.05-3.4,2.68-5.17,4s-3.63,2.5-5.53,3.63-3.82,2.19-5.8,3.16a25.57,25.57,0,0,1-3.09,1.31,5.38,5.38,0,0,1-3,.42,11.88,11.88,0,0,1-2.91-1.62c-1.18-.73-2.36-1.44-3.51-2.2C128.79,207.92,128.83,207.83,128.89,207.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129,207.28,116.8,222.84s-14.44-13.07-19.42-24.12.73-13.53,12.94-4.67C122.26,202.72,129,207.28,129,207.28Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.21,198.22c2.1,1.34,4.14,2.79,6.15,4.23,1,.71,2,1.42,2.92,2.14l1.53,1.15a12,12,0,0,0,1.73,1.22c.11.06,0,.22-.09.14a23.57,23.57,0,0,0-3.09-2.09c-1.07-.7-2.12-1.42-3.17-2.16-2-1.45-4.1-2.95-6-4.56A0,0,0,0,1,116.21,198.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.73,208.8a13.61,13.61,0,0,0,1.79,1.33c.25.15.49.32.73.48-1.2-1.44-2.37-2.91-3.46-4.42,0,0,0-.06,0,0,2.59,2.8,5,5.73,7.62,8.52s5.1,5.86,7.85,8.58a.08.08,0,1,1-.11.11c-2.69-2.77-5.53-5.37-8.08-8.27-1-1.16-2-2.33-3-3.51a5.31,5.31,0,0,1-.81-.52c-.3-.22-.61-.44-.89-.68-.57-.5-1.14-1-1.74-1.45C102.55,208.86,102.66,208.73,102.73,208.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.27,208.09l-4.92-2.93L114.42,223l4.28,4.1Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.09,220.64c1.7-2.37,3.58-4.62,5.38-6.9s3.79-4.46,5.52-6.81c.06-.09.19,0,.13.1-1.77,2.32-3.36,4.78-5.18,7.06a86.37,86.37,0,0,1-5.71,6.66A.09.09,0,0,1,116.09,220.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.1,223.94c-.91,1-1.76,2-2.59,3l.35,0c-1.39-1.4-2.83-2.76-4.34-4v.19c.32-.47.64-.94.94-1.42-.4.4-.78.82-1.16,1.25l-.08.09.09.1c1.34,1.45,2.76,2.83,4.21,4.17l.2.18.16-.21C119.65,226.15,120.41,225.07,121.1,223.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.06,193.91c-3.25-.15-10.48-5-12.12-9.2-.11-.28.66-3,1.43-6.44.45-2.06.92-4.37,1.18-6.51.06-.44,1.45.56,1.45.56l2.68,1,8.87,3.38a34.43,34.43,0,0,0-2.33,8,5.34,5.34,0,0,0,0,.89S114.06,193.91,114.06,193.91Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.2,185.64a.74.74,0,0,1,0,.15,8.7,8.7,0,0,1-1.38-.11c-9-1.33-8.69-13-8.69-13l3.55.6,8.87,3.38a34.43,34.43,0,0,0-2.33,8A5.34,5.34,0,0,0,115.2,185.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105,156.89c-1.92,4.62-.74,18.64,2.35,22,4.48,4.93,12.49,6.14,16.85.6,4.22-5.38,2.36-23.62-1.16-26.78C117.9,148.1,107.87,150.05,105,156.89Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.06,178.76h0",
    style: {
      fill: "none",
      stroke: "#f6a89f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.29,167.11s-.07,0-.06.09c.1.94.06,2-.77,2.42,0,0,0,.06,0,0C117.5,169.44,117.54,168,117.29,167.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.37,166.19c-1.53,0-1.41,3.06,0,3.06S117.65,166.19,116.37,166.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.09,166.75s.08,0,.08.08c0,.95.18,2,1,2.32a0,0,0,0,1,0,0C123.16,169.09,123,167.65,123.09,166.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.9,165.73c1.52-.18,1.76,2.87.35,3S122.63,165.88,123.9,165.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.11,164.84a11.66,11.66,0,0,0,1.16-.46,2,2,0,0,0,1.1-.7.65.65,0,0,0-.13-.78,1.59,1.59,0,0,0-1.62-.1,2.34,2.34,0,0,0-1.32,1.07A.69.69,0,0,0,115.11,164.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,164.14c-.43,0-.81-.17-1.23-.26a2.1,2.1,0,0,1-1.2-.51.65.65,0,0,1,0-.79,1.61,1.61,0,0,1,1.58-.37,2.39,2.39,0,0,1,1.48.84A.69.69,0,0,1,125,164.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.83,175.62c.23.21.47.51.82.53a2.5,2.5,0,0,0,1-.28,0,0,0,0,1,0,0,1.27,1.27,0,0,1-1.18.57,1,1,0,0,1-.78-.81C116.72,175.61,116.79,175.59,116.83,175.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.71,172.75a3.23,3.23,0,0,0,2.21,1.35,4.1,4.1,0,0,0,1.16,0,.78.78,0,0,0,.22,0l.21,0a.25.25,0,0,0,.18-.22h0s0-.06,0-.1h0v-.09c0-.72-.13-1.83-.13-1.83.28.12,1.66.68,1.62.3a48.09,48.09,0,0,0-1.64-9.71c0-.1-.19-.07-.17,0,.18,3,.9,6,1.13,9.07a5.7,5.7,0,0,0-1.54-.41c-.1,0,.26,2.14.24,2.47v0a4.48,4.48,0,0,1-3.38-.9C117.72,172.61,117.65,172.67,117.71,172.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.87,156.89c-4.35,3.63-11.17-.59-11.17-.59a5.1,5.1,0,0,1-4.84,3.69s-.16,8-2.24,8.15c-3.17.28-5.16-10.37-4.37-12.58a5.66,5.66,0,0,1,3.43-3,5.24,5.24,0,0,1,1.86-3.34c2-1.86,9.67-.34,9.67-.34a6.92,6.92,0,0,1,1.67-2.76,2,2,0,0,1,2.84,0,4.74,4.74,0,0,0-.57,2c-.16,2.34,1.73,2.16,1.51.07a3.3,3.3,0,0,0-.94-2.09c.8-1.45,2.28-2,3.27-1.4C125.79,145.88,127.49,153.87,123.87,156.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.89,168.4s-2.78-4.7-4.89-3.75-.26,7.61,2,8.68a2.43,2.43,0,0,0,3.34-1.06Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.58,166.55s0,0,0,.06a6.09,6.09,0,0,1,2.87,4.06,1.34,1.34,0,0,0-2-.51s0,.09,0,.09a1.48,1.48,0,0,1,1.59.64,6.89,6.89,0,0,1,.68,1.39c.07.15.35.09.3-.08v0C106.27,170,104.84,166.93,102.58,166.55Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubbles--inject-86"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.23,225a12.12,12.12,0,0,1-2.08-6.7c0-8.5,9.33-15.39,20.84-15.39s20.82,6.89,20.82,15.39-9.32,15.38-20.82,15.38a24.93,24.93,0,0,1-14.37-4.26l-7.18,1.83Z",
    style: {
      fill: "#138DE8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.48,218.29a2.16,2.16,0,1,0,2.16-2.16A2.15,2.15,0,0,0,282.48,218.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.82,218.29a2.16,2.16,0,1,0,2.16-2.16A2.16,2.16,0,0,0,272.82,218.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.17,218.29a2.16,2.16,0,1,0,2.16-2.16A2.16,2.16,0,0,0,263.17,218.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.43,278.71a12.12,12.12,0,0,1-2.08-6.7c0-8.5,9.33-15.39,20.83-15.39S458,263.51,458,272s-9.32,15.38-20.83,15.38a25,25,0,0,1-14.37-4.25L415.64,285Z",
    style: {
      fill: "#138DE8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.67,272a2.16,2.16,0,1,0,2.16-2.16A2.16,2.16,0,0,0,444.67,272Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435,272a2.16,2.16,0,1,0,2.16-2.16A2.16,2.16,0,0,0,435,272Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.37,272a2.16,2.16,0,1,0,2.16-2.16A2.16,2.16,0,0,0,425.37,272Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.06,315.37a12.15,12.15,0,0,0,2.08-6.71c0-8.5-9.33-15.38-20.83-15.38s-20.83,6.88-20.83,15.38,9.33,15.39,20.83,15.39a25,25,0,0,0,14.37-4.26l7.17,1.82Z",
    style: {
      fill: "#138DE8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.82,308.66a2.16,2.16,0,1,1-2.16-2.16A2.16,2.16,0,0,1,55.82,308.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.47,308.66a2.16,2.16,0,1,1-2.16-2.16A2.16,2.16,0,0,1,65.47,308.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.12,308.66A2.16,2.16,0,1,1,73,306.5,2.16,2.16,0,0,1,75.12,308.66Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineWorld);
export default __webpack_public_path__ + "static/media/online-world.c27c3920f3dbd57aec421cab00a35ff7.svg";
export { ForwardRef as ReactComponent };